import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef, forwardRef } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Card, CardBody, Nav, Row, Col, Modal, Button, Form, Stack } from "react-bootstrap";
import ImageBst from "react-bootstrap/Image";
import { formatNumber } from "utils/HelperFunction";
import Select from "react-select";
import { Formik } from "formik";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { ModalAllder } from "layouts/ModalAllder";
import { TagsInput } from "react-tag-input-component";
import DownloadExcel from "utils/DownloadExcel";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { initState } from "mocks/poData";
import moment from "moment";
import "moment/locale/th";
import { getDiscountValue, NumberFormat, WDA, getPrefixName, filterTextAndNum, getInfoAdminSystem } from "utils/HelperFunction";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import EditIcon from "@mui/icons-material/Edit";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PhoneIcon from "@mui/icons-material/Phone";
import NotesIcon from "@mui/icons-material/Notes";
import ButtonMui from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import AddIcon from "@mui/icons-material/Add";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { getAllDataRsreserve, clearGetAllDataRsreserve } from "../../redux/handlers/reservation/getAllDataRsreserve.handler";
import { updateStatusSales, clearUpdateStatusSales } from "../../redux/handlers/reservation/updateStatusSales.handler";
import { updateStatusReserve, clearUpdateStatusReserve } from "../../redux/handlers/reservation/updateStatusReserve.handler";
import { getDataRsreserveById, clearGetDataRsreserveById } from "../../redux/handlers/reservation/getDataRsreserveById.handler";
import { getDataCatalogById, clearGetDataCatalogById } from "../../redux/handlers/reservation/getDataCatalogById.handler";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import CursorManager from "layouts/CursorManager";
import { useReactToPrint } from "react-to-print";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { getShop } from "../../redux/handlers/manage/getShop.handler";
import { getReservationCreateShop } from "../../redux/handlers/reservation/getReservationCreateShop.handler";
import { createReservation, clearCreateReservation } from "../../redux/handlers/reservation/createReservation.handler";
import { Page, Text, View, Document, StyleSheet, Font, Image, Svg, Rect, Path, pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { Buffer } from "buffer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import sarabun from "fonts/SarabunRegular.ttf";
import sarabunBold from "fonts/SarabunSemiBold.ttf";
import phetsarath from "fonts/PhetsarathRegular.ttf";
import phetsarathBold from "fonts/PhetsarathBold.ttf";
Font.register({
    family: "Sarabun",
    fonts: [
        {
            src: sarabun
        },
        {
            src: sarabunBold,
            fontWeight: "bold"
        }
    ]
});
Font.register({
    family: "Phetsarath",
    fonts: [
        {
            src: phetsarath
        },
        {
            src: phetsarathBold,
            fontWeight: "bold"
        }
    ]
});
var statusContactShow = [
    "ไม่ระบุ",
    "รอติดต่อ",
    "ยืนยันแล้ว",
    "ยกเลิก",
    "รีสถานะ"
];
var RESERVE_STATUS_RESET = 99;
var DOC_TYPE_PICKING = 1;
var DOC_TYPE_DELIVERY = 2;
var DOC_TYPE_PENDING = 3;
var DOC_TYPE_SHIPPING_LABEL = 5;
var DOC_TYPE_NO_DELIVERY = 4;
var formatPdfBranchName = function(name, code) {
    var branchName = String(name || "").trim();
    var branchCode = String(code || "").trim();
    return [
        branchName,
        branchCode ? "(".concat(branchCode, ")") : ""
    ].filter(Boolean).join(" ");
};
var PDF_FONT_SIZE_BASE = 8;
var PDF_FONT_SIZE_SUBTITLE = 12;
var PDF_FONT_SIZE_TITLE = 14;
var CODE128_PATTERNS = [
    "212222",
    "222122",
    "222221",
    "121223",
    "121322",
    "131222",
    "122213",
    "122312",
    "132212",
    "221213",
    "221312",
    "231212",
    "112232",
    "122132",
    "122231",
    "113222",
    "123122",
    "123221",
    "223211",
    "221132",
    "221231",
    "213212",
    "223112",
    "312131",
    "311222",
    "321122",
    "321221",
    "312212",
    "322112",
    "322211",
    "212123",
    "212321",
    "232121",
    "111323",
    "131123",
    "131321",
    "112313",
    "132113",
    "132311",
    "211313",
    "231113",
    "231311",
    "112133",
    "112331",
    "132131",
    "113123",
    "113321",
    "133121",
    "313121",
    "211331",
    "231131",
    "213113",
    "213311",
    "213131",
    "311123",
    "311321",
    "331121",
    "312113",
    "312311",
    "332111",
    "314111",
    "221411",
    "431111",
    "111224",
    "111422",
    "121124",
    "121421",
    "141122",
    "141221",
    "112214",
    "112412",
    "122114",
    "122411",
    "142112",
    "142211",
    "241211",
    "221114",
    "413111",
    "241112",
    "134111",
    "111242",
    "121142",
    "121241",
    "114212",
    "124112",
    "124211",
    "411212",
    "421112",
    "421211",
    "212141",
    "214121",
    "412121",
    "111143",
    "111341",
    "131141",
    "114113",
    "114311",
    "411113",
    "411311",
    "113141",
    "114131",
    "311141",
    "411131",
    "211412",
    "211214",
    "211232",
    "2331112"
];
var encodeCode128 = function(rawValue) {
    var value = String(rawValue !== null && rawValue !== void 0 ? rawValue : "").trim();
    if (!value || !/^[\x20-\x7E]+$/.test(value)) return null;
    var startCode = 104;
    var dataCodes = [];
    if (/^\d+$/.test(value) && value.length >= 4) {
        if (value.length % 2 === 0) {
            startCode = 105;
            dataCodes = value.match(/\d{2}/g).map(Number);
        } else {
            dataCodes = [
                value.charCodeAt(0) - 32,
                99
            ].concat(_to_consumable_array(value.slice(1).match(/\d{2}/g).map(Number)));
        }
    } else {
        dataCodes = Array.from(value, function(character) {
            return character.charCodeAt(0) - 32;
        });
    }
    var checksum = (startCode + dataCodes.reduce(function(total, code, index) {
        return total + code * (index + 1);
    }, 0)) % 103;
    var codes = [
        startCode
    ].concat(_to_consumable_array(dataCodes), [
        checksum,
        106
    ]);
    var quietZone = 10;
    var bars = [];
    var position = quietZone;
    codes.forEach(function(code) {
        var pattern = CODE128_PATTERNS[code];
        Array.from(pattern).forEach(function(widthText, index) {
            var width = Number(widthText);
            if (index % 2 === 0) bars.push({
                x: position,
                width: width
            });
            position += width;
        });
    });
    return {
        bars: bars,
        totalModules: position + quietZone,
        value: value
    };
};
var PdfBarcode = function(param) {
    var value = param.value, _param_height = param.height, height = _param_height === void 0 ? 25 : _param_height, _param_viewBoxHeight = param.viewBoxHeight, viewBoxHeight = _param_viewBoxHeight === void 0 ? 40 : _param_viewBoxHeight, _param_textGap = param.textGap, textGap = _param_textGap === void 0 ? 1 : _param_textGap;
    var barcode = encodeCode128(value);
    if (!barcode) {
        return /*#__PURE__*/ _jsx(Text, {
            style: {
                fontSize: 6,
                textAlign: "center"
            },
            children: value || "-"
        });
    }
    return /*#__PURE__*/ _jsxs(View, {
        wrap: false,
        style: {
            width: "100%",
            paddingHorizontal: 0,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ _jsx(Svg, {
                width: "100%",
                height: height,
                viewBox: "0 0 ".concat(barcode.totalModules, " ").concat(viewBoxHeight),
                preserveAspectRatio: "none",
                children: barcode.bars.map(function(bar, index) {
                    return /*#__PURE__*/ _jsx(Rect, {
                        x: bar.x,
                        y: 0,
                        width: bar.width,
                        height: 25,
                        fill: "#000000"
                    }, "".concat(bar.x, "-").concat(index));
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                style: {
                    fontSize: 8,
                    marginTop: textGap,
                    textAlign: "center",
                    letterSpacing: 0.25
                },
                children: barcode.value
            })
        ]
    });
};
var getPdfDocumentName = function(docType) {
    if (docType === DOC_TYPE_SHIPPING_LABEL) return "ใบปะหน้า";
    if (docType === DOC_TYPE_DELIVERY) return "ใบส่งสินค้า";
    if (docType === DOC_TYPE_PENDING) return "ใบจอง";
    if (docType === DOC_TYPE_NO_DELIVERY) return "ใบสินค้าไม่พร้อมจัดส่ง";
    return "ใบจัดสินค้า";
};
var getPdfDocumentNumber = function(docType) {
    if (docType === DOC_TYPE_PENDING) return 1;
    if (docType === DOC_TYPE_DELIVERY) return 3;
    if (docType === DOC_TYPE_NO_DELIVERY) return 4;
    if (docType === DOC_TYPE_SHIPPING_LABEL) return 5;
    return 2;
};
var getReservationCatalogSortId = function(item) {
    var id = Number(item === null || item === void 0 ? void 0 : item.rs_catalog_id);
    if (Number.isFinite(id) && id > 0) return id;
    var catalogId = Number(item === null || item === void 0 ? void 0 : item.rs_catalog_clid);
    return Number.isFinite(catalogId) ? catalogId : 0;
};
var sortReservationCatalogItems = function(items) {
    return Array.isArray(items) ? _to_consumable_array(items).sort(function(a, b) {
        return getReservationCatalogSortId(a) - getReservationCatalogSortId(b);
    }) : [];
};
var isComplimentaryReserveCatalog = function(catalog) {
    return Number(catalog === null || catalog === void 0 ? void 0 : catalog.rs_catalog_free) === 2 || Number(catalog === null || catalog === void 0 ? void 0 : catalog.rs_catalog_tester) === 2;
};
var formatDbDate = function(value) {
    if (!value) return "-";
    var dateText = String(value).slice(0, 10);
    return moment(dateText, "YYYY-MM-DD", true).isValid() ? moment(dateText, "YYYY-MM-DD").format("DD/MM/YYYY") : moment(value).format("DD/MM/YYYY");
};
var formatDbDateTime = function(value) {
    if (!value) return "-";
    var parsed = moment.utc(value);
    return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : "-";
};
var getReserveDetailUnitPrice = function(detail, vatCal) {
    if (detail.rs_detail_wholesaleavg && detail.rs_detail_wholesaleavg > 0) {
        return detail.rs_detail_wholesaleavg;
    }
    if (Number(vatCal || 1) === 1) {
        return detail.rs_detail_wholesaledis && detail.rs_detail_wholesaledis > 0 ? detail.rs_detail_wholesaledis : detail.rs_detail_wholesale || 0;
    }
    return detail.rs_detail_wholesalevatdis && detail.rs_detail_wholesalevatdis > 0 ? detail.rs_detail_wholesalevatdis : detail.rs_detail_wholesalevat || 0;
};
var getLakExchangeRate = function(dataFrom) {
    var rate = Number((dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.system_bahttolak) || 0);
    return Number.isFinite(rate) && rate > 0 ? rate : 0;
};
var getLakAmount = function(value, exchangeRate) {
    return (Number(value) || 0) * (Number(exchangeRate) || 0);
};
var pdfLakTextStyle = {
    color: "#777777",
    fontSize: PDF_FONT_SIZE_BASE - 0.5
};
var formatFileSize = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (!size || size < 1024) {
        return "".concat(size || 0, " B");
    }
    if (size < 1024 * 1024) {
        return "".concat((size / 1024).toFixed(1), " KB");
    }
    return "".concat((size / (1024 * 1024)).toFixed(1), " MB");
};
var statusListShow = [
    "ไม่ระบุ",
    "รอยืนยัน",
    "ส่งสินค้าแล้ว",
    "ยกเลิก",
    "กำลังจัดสินค้า",
    "รอส่งสินค้า",
    "",
    "ตรวจสอบสินค้า"
];
var optionsStatusContact = [
    {
        value: 1,
        label: "รอติดต่อ"
    },
    {
        value: 2,
        label: "ยืนยันแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    },
    {
        value: 4,
        label: "รีสถานะ"
    }
];
var optionsStatusList = [
    {
        value: 1,
        label: "รอยืนยัน"
    },
    {
        value: 4,
        label: "กำลังจัดสินค้า"
    },
    {
        value: 7,
        label: "ตรวจสอบสินค้า"
    },
    {
        value: 5,
        label: "รอส่งสินค้า"
    },
    {
        value: 2,
        label: "ส่งสินค้าแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    },
    {
        value: RESERVE_STATUS_RESET,
        label: "รีสถานะ"
    }
];
var statusCountText = function() {
    var counts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, group = arguments.length > 1 ? arguments[1] : void 0, statusId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var _groupCounts_by_status;
    var groupCounts = counts[group] || {};
    var value = Number(statusId) === 0 ? groupCounts.all : (_groupCounts_by_status = groupCounts.by_status) === null || _groupCounts_by_status === void 0 ? void 0 : _groupCounts_by_status[String(statusId)];
    return NumberFormat(Number(value || 0), 0);
};
var getReserveStatusStyle = function() {
    var statusId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (statusId === 4) {
        return {
            color: "#0a58ca",
            backgroundColor: "#e7f1ff"
        };
    }
    if (statusId === 5) {
        return {
            color: "#8a4b00",
            backgroundColor: "#fff3cd"
        };
    }
    if (statusId === 7) {
        return {
            color: "#0f766e",
            backgroundColor: "#ccfbf1"
        };
    }
    if (statusId === 2) {
        return {
            color: "#ffffff",
            backgroundColor: "#10b02a"
        };
    }
    if (statusId === 6) {
        return {
            color: "#075985",
            backgroundColor: "#e0f2fe"
        };
    }
    if (statusId === 3) {
        return {
            color: "rgba(211, 47, 47, 1)",
            backgroundColor: "rgba(253, 237, 237, 1)"
        };
    }
    if (statusId === 1) {
        return {
            color: "rgba(253, 180, 40, 1)",
            backgroundColor: "rgba(255, 246, 229, 1)"
        };
    }
    return {
        color: "rgba(116, 116, 116, 1)",
        backgroundColor: "rgba(244, 244, 244, 1)"
    };
};
var getReserveStatusOptions = function() {
    var currentStatus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, userRoleId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, reservationManagementOnly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (reservationManagementOnly) {
        if (Number(currentStatus) === WAIT_DELIVERY_STATUS) {
            return optionsStatusList.filter(function(item) {
                return item.value === 2;
            });
        }
        if (Number(currentStatus) === 2) {
            return [
                {
                    value: 6,
                    label: "ชำระเงินแล้ว"
                }
            ];
        }
        if (Number(currentStatus) === 6) {
            return [
                {
                    value: 2,
                    label: "รีเซ็ตไปส่งสินค้าแล้ว"
                }
            ];
        }
        return [];
    }
    switch(currentStatus){
        case 1:
            return optionsStatusList.filter(function(item) {
                return item.value === 4 || item.value === 3;
            });
        case 4:
            return optionsStatusList.filter(function(item) {
                return item.value === 7 && Number(userRoleId) === 9 || item.value === 3 || item.value === RESERVE_STATUS_RESET;
            });
        case 7:
            return optionsStatusList.filter(function(item) {
                return item.value === 7 || item.value === RESERVE_STATUS_RESET;
            });
        case 5:
            return optionsStatusList.filter(function(item) {
                return item.value === 2 || item.value === 6 || item.value === 3 || item.value === RESERVE_STATUS_RESET;
            });
        case 2:
            return [
                {
                    value: 6,
                    label: "ชำระเงินแล้ว"
                },
                {
                    value: RESERVE_STATUS_RESET,
                    label: "รีสถานะ"
                }
            ];
        case 6:
            return [
                {
                    value: 2,
                    label: "รีเซ็ตไปส่งสินค้าแล้ว"
                },
                {
                    value: RESERVE_STATUS_RESET,
                    label: "รีสถานะ"
                }
            ];
        default:
            return [];
    }
};
var TEXT_PREVIEW_LIMIT = 50;
var WAIT_DELIVERY_STATUS = 5;
var WAIT_DELIVERY_HIDDEN_COLUMNS = new Set([
    "จัดการ",
    "สถานะเซลล์ติดต่อลูกค้า",
    "จำนวนชิ้นที่จอง",
    "เซลล์",
    "วันที่เซลล์ติดต่อ",
    "กำลังจัดสินค้า",
    "ตรวจสอบสินค้า",
    "ส่งสินค้าแล้ว",
    "วันที่จัดสินค้า",
    "คาดว่าจัดส่งสินค้า",
    "วันที่ส่งสินค้าจริง",
    "วันที่ชำระเงิน",
    "ราคาจองรวม",
    "ประเภทร้านค้า"
]);
var WAIT_DELIVERY_COLUMN_LAYOUT = {
    "สถานะ": {
        grow: 11,
        minWidth: "150px"
    },
    "รหัสใบจอง": {
        grow: 12,
        minWidth: "170px"
    },
    "วันที่จอง": {
        grow: 13,
        minWidth: "170px"
    },
    "ชื่อร้าน": {
        grow: 20,
        minWidth: "250px"
    },
    "รอส่งสินค้า": {
        grow: 13,
        minWidth: "170px"
    },
    "บ้าน": {
        grow: 10,
        minWidth: "140px"
    },
    "เมือง": {
        grow: 10,
        minWidth: "140px"
    },
    "แขวง": {
        grow: 10,
        minWidth: "140px"
    },
    "จำนวนชิ้นที่ส่งจริง": {
        grow: 12,
        minWidth: "160px"
    },
    "ราคาส่งจริงรวม": {
        grow: 13,
        minWidth: "160px"
    }
};
var RESERVATION_MANAGEMENT_HIDDEN_COLUMNS = new Set([
    "กำลังจัดสินค้า",
    "ตรวจสอบสินค้า",
    "รอส่งสินค้า",
    "ส่งสินค้าแล้ว",
    "วันที่จัดสินค้า",
    "คาดว่าจัดส่งสินค้า",
    "วันที่ส่งสินค้าจริง"
]);
var integerText = function(value) {
    return formatNumber(Number(value || 0), 0) || "0";
};
export function ReportReservation(param) {
    var _param_waitDeliveryOnly = param.waitDeliveryOnly, waitDeliveryOnly = _param_waitDeliveryOnly === void 0 ? false : _param_waitDeliveryOnly, _param_reservationManagementOnly = param.reservationManagementOnly, reservationManagementOnly = _param_reservationManagementOnly === void 0 ? false : _param_reservationManagementOnly;
    var navigate = useNavigate();
    var location = useLocation();
    var dispatch = useAppDispatch();
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var userRoleId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) || 0);
    var isSalesRole = [
        3,
        4
    ].includes(userRoleId);
    var isWarehouseRole = [
        6,
        9
    ].includes(userRoleId);
    var canCreateReservation = [
        1,
        2,
        3,
        4
    ].includes(userRoleId);
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var queryParams = useMemo(function() {
        return new URLSearchParams(location.search);
    }, [
        location.search
    ]);
    var getQueryNumber = function(key) {
        var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var value = parseInt(queryParams.get(key), 10);
        return Number.isFinite(value) ? value : defaultValue;
    };
    var _useState = _sliced_to_array(useState([]), 2), tableData = _useState[0], setTableData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), excelData = _useState1[0], setExcelData = _useState1[1];
    var _useState2 = _sliced_to_array(useState(queryParams.get("searchtext") || ""), 2), filterText = _useState2[0], setFilterText = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), filteredItems = _useState3[0], setFilteredItems = _useState3[1];
    var _useState4 = _sliced_to_array(useState(getQueryNumber("pageId", 1)), 2), pageId = _useState4[0], setPageId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(getQueryNumber("pageSize", 10)), 2), pageSize = _useState5[0], setPageSize = _useState5[1];
    var _useState6 = _sliced_to_array(useState(queryParams.get("sortField") && queryParams.get("sortValue") ? {
        sortField: queryParams.get("sortField"),
        sortValue: queryParams.get("sortValue")
    } : waitDeliveryOnly ? {
        sortField: "rs_reserve_waitdate",
        sortValue: "asc"
    } : {}), 2), sortModel = _useState6[0], setSortModel = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), loading = _useState7[0], setLoading = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), totalPage = _useState8[0], setTotalPage = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), totalAmount = _useState9[0], setTotalAmount = _useState9[1];
    var _useState10 = _sliced_to_array(useState({}), 2), statusCounts = _useState10[0], setStatusCounts = _useState10[1];
    var _useState11 = _sliced_to_array(useState(waitDeliveryOnly ? String(WAIT_DELIVERY_STATUS) : queryParams.get("status") || "0"), 2), tabStatus = _useState11[0], setTabStatus = _useState11[1];
    var _useState12 = _sliced_to_array(useState(waitDeliveryOnly ? "0" : queryParams.get("salestatus") || "0"), 2), tabSaleStatus = _useState12[0], setTabSaleStatus = _useState12[1];
    var _useState13 = _sliced_to_array(useState(false), 2), reData = _useState13[0], setReData = _useState13[1];
    var _useState14 = _sliced_to_array(useState(waitDeliveryOnly ? WAIT_DELIVERY_STATUS : getQueryNumber("status", 0)), 2), statusCt = _useState14[0], setStatusCt = _useState14[1];
    var _useState15 = _sliced_to_array(useState(waitDeliveryOnly ? 0 : getQueryNumber("salestatus", 0)), 2), saleStatusCt = _useState15[0], setSaleStatusCt = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState16[0], setModalsuccess = _useState16[1];
    var _useState17 = _sliced_to_array(useState(false), 2), chgStSalesShow = _useState17[0], setChgStSalesShow = _useState17[1];
    var handleChgSalesShow = function() {
        return setChgStSalesShow(true);
    };
    var handleChgSalesClose = function() {
        return setChgStSalesShow(false);
    };
    var _useState18 = _sliced_to_array(useState(0), 2), statusId = _useState18[0], setStatusId = _useState18[1];
    var _useState19 = _sliced_to_array(useState(0), 2), reportId = _useState19[0], setReportId = _useState19[1];
    var _useState20 = _sliced_to_array(useState(""), 2), reserveCode = _useState20[0], setReserveCode = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), reserveResetNote = _useState21[0], setReserveResetNote = _useState21[1];
    var _useState22 = _sliced_to_array(useState(1), 2), reserveBranchCreditStatus = _useState22[0], setReserveBranchCreditStatus = _useState22[1];
    var _useState23 = _sliced_to_array(useState({
        show: false,
        text: ""
    }), 2), cancelNoteModal = _useState23[0], setCancelNoteModal = _useState23[1];
    var _useState24 = _sliced_to_array(useState({
        show: false,
        problem: "",
        note: ""
    }), 2), deliveryProblemModal = _useState24[0], setDeliveryProblemModal = _useState24[1];
    var _useState25 = _sliced_to_array(useState([]), 2), deliveryProblemOptions = _useState25[0], setDeliveryProblemOptions = _useState25[1];
    var _useState26 = _sliced_to_array(useState(false), 2), chgStListShow = _useState26[0], setChgStListShow = _useState26[1];
    var handleChgListShow = function() {
        return setChgStListShow(true);
    };
    var handleChgListClose = function() {
        return setChgStListShow(false);
    };
    var _useState27 = _sliced_to_array(useState(0), 2), reportListId = _useState27[0], setReportListId = _useState27[1];
    var _useState28 = _sliced_to_array(useState(0), 2), stListId = _useState28[0], setStListId = _useState28[1];
    var _useState29 = _sliced_to_array(useState(""), 2), reserveCodeList = _useState29[0], setReserveCodeList = _useState29[1];
    var _useState30 = _sliced_to_array(useState(0), 2), statusSale = _useState30[0], setStatusSale = _useState30[1];
    var _useState31 = _sliced_to_array(useState({
        show: false,
        text: ""
    }), 2), shopNameModal = _useState31[0], setShopNameModal = _useState31[1];
    var _useState32 = _sliced_to_array(useState({}), 2), reservationData = _useState32[0], setReservationData = _useState32[1];
    var _useState33 = _sliced_to_array(useState([]), 2), dataItem = _useState33[0], setDataItem = _useState33[1];
    var _useState34 = _sliced_to_array(useState(false), 2), openPrint = _useState34[0], setOpenPrint = _useState34[1];
    var _useState35 = _sliced_to_array(useState(DOC_TYPE_PICKING), 2), printDocType = _useState35[0], setPrintDocType = _useState35[1];
    var _useState36 = _sliced_to_array(useState(0), 2), reportPrintId = _useState36[0], setReportPrintId = _useState36[1];
    var _useState37 = _sliced_to_array(useState(""), 2), copiedTrackingCode = _useState37[0], setCopiedTrackingCode = _useState37[1];
    var _useState38 = _sliced_to_array(useState({
        open: false,
        severity: "success",
        message: ""
    }), 2), copyTrackingNotice = _useState38[0], setCopyTrackingNotice = _useState38[1];
    var _useState39 = _sliced_to_array(useState(false), 2), createReservationShow = _useState39[0], setCreateReservationShow = _useState39[1];
    var _useState40 = _sliced_to_array(useState(""), 2), createShopId = _useState40[0], setCreateShopId = _useState40[1];
    var _useState41 = _sliced_to_array(useState(""), 2), createBranchId = _useState41[0], setCreateBranchId = _useState41[1];
    var _useState42 = _sliced_to_array(useState([]), 2), optionShop = _useState42[0], setOptionShop = _useState42[1];
    var _useState43 = _sliced_to_array(useState([]), 2), filShop = _useState43[0], setFilShop = _useState43[1];
    var _useState44 = _sliced_to_array(useState(queryParams.get("shopid") || ""), 2), shopId = _useState44[0], setShopId = _useState44[1];
    var _useState45 = _sliced_to_array(useState([]), 2), optionSale = _useState45[0], setOptionSale = _useState45[1];
    var _useState46 = _sliced_to_array(useState(queryParams.get("saleid") || ""), 2), saleId = _useState46[0], setSaleId = _useState46[1];
    var _useState47 = _sliced_to_array(useState([]), 2), optionAdmin = _useState47[0], setOptionAdmin = _useState47[1];
    var _useState48 = _sliced_to_array(useState(queryParams.get("adminid") || ""), 2), adminId = _useState48[0], setAdminId = _useState48[1];
    var _useState49 = _sliced_to_array(useState(null), 2), sDate = _useState49[0], setSDate = _useState49[1];
    var _useState50 = _sliced_to_array(useState(null), 2), eDate = _useState50[0], setEDate = _useState50[1];
    var _useState51 = _sliced_to_array(useState("custom"), 2), dateRange = _useState51[0], setDateRange = _useState51[1];
    var _useState52 = _sliced_to_array(useState(queryParams.get("typeshop") || ""), 2), shopTypeId = _useState52[0], setShopTypeId = _useState52[1];
    var optionShopType = [
        {
            value: "",
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "RT"
        },
        {
            value: 2,
            label: "WT"
        },
        {
            value: 3,
            label: "MT"
        }
    ];
    var selectMenuPortalProps = {
        menuPortalTarget: document.body,
        menuPosition: "fixed",
        styles: {
            menuPortal: function(base) {
                return _object_spread_props(_object_spread({}, base), {
                    zIndex: 9999
                });
            },
            menu: function(base) {
                return _object_spread_props(_object_spread({}, base), {
                    zIndex: 9999
                });
            }
        }
    };
    var reservationListQuery = useMemo(function() {
        var params = new URLSearchParams();
        params.set("pageId", String(pageId));
        params.set("pageSize", String(pageSize));
        if (filterText) params.set("searchtext", filterText);
        if (statusCt) params.set("status", String(statusCt));
        if (!waitDeliveryOnly && saleStatusCt) {
            params.set("salestatus", String(saleStatusCt));
        }
        if (shopId) params.set("shopid", String(shopId));
        if (!waitDeliveryOnly && saleId) params.set("saleid", String(saleId));
        if (!waitDeliveryOnly && adminId) params.set("adminid", String(adminId));
        if (!waitDeliveryOnly && shopTypeId) {
            params.set("typeshop", String(shopTypeId));
        }
        if ((sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortField) && (sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortValue)) {
            params.set("sortField", sortModel.sortField);
            params.set("sortValue", sortModel.sortValue);
        }
        var query = params.toString();
        return query ? "?".concat(query) : "";
    }, [
        pageId,
        pageSize,
        filterText,
        statusCt,
        saleStatusCt,
        shopId,
        saleId,
        adminId,
        shopTypeId,
        sortModel,
        waitDeliveryOnly
    ]);
    var reservationListDirection = "".concat(location.pathname).concat(reservationListQuery);
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setSDate(range.startDate);
            setEDate(range.endDate);
        }
        setPageId(1);
    };
    var getAllDataRsreserveReducer = useAppSelector(function(state) {
        return state.getAllDataRsreserveReducer;
    });
    var getDataRsreserveByIdReducer = useAppSelector(function(state) {
        return state.getDataRsreserveByIdReducer;
    });
    var getDataCatalogByIdReducer = useAppSelector(function(state) {
        return state.getDataCatalogByIdReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var getShopReducer = useAppSelector(function(state) {
        return state.getShopReducer;
    });
    var getReservationCreateShopReducer = useAppSelector(function(state) {
        return state.getReservationCreateShopReducer;
    });
    var createReservationReducer = useAppSelector(function(state) {
        return state.createReservationReducer;
    });
    var creatingReservation = createReservationReducer.isFetching;
    var availableCreateBranches = useMemo(function() {
        var _getReservationCreateShopReducer_data;
        var branches = (getReservationCreateShopReducer === null || getReservationCreateShopReducer === void 0 ? void 0 : (_getReservationCreateShopReducer_data = getReservationCreateShopReducer.data) === null || _getReservationCreateShopReducer_data === void 0 ? void 0 : _getReservationCreateShopReducer_data.data) || [];
        return userRoleId === 3 ? branches.filter(function(branch) {
            return Number(branch === null || branch === void 0 ? void 0 : branch.sh_branch_intendant) === Number(adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId);
        }) : branches;
    }, [
        getReservationCreateShopReducer === null || getReservationCreateShopReducer === void 0 ? void 0 : getReservationCreateShopReducer.data,
        userRoleId,
        adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId
    ]);
    var createShopOptions = useMemo(function() {
        var shops = new Map();
        availableCreateBranches.forEach(function(branch) {
            var id = Number(branch === null || branch === void 0 ? void 0 : branch.sh_branch_shid);
            if (id && !shops.has(id)) {
                var _branch_shShop, _branch_shShop_sh_shop_code, _branch_shShop1;
                var shopName = (branch === null || branch === void 0 ? void 0 : (_branch_shShop = branch.shShop) === null || _branch_shShop === void 0 ? void 0 : _branch_shShop.sh_shop_name) || "ร้านค้า ".concat(id);
                var shopCode = branch === null || branch === void 0 ? void 0 : (_branch_shShop1 = branch.shShop) === null || _branch_shShop1 === void 0 ? void 0 : (_branch_shShop_sh_shop_code = _branch_shShop1.sh_shop_code) === null || _branch_shShop_sh_shop_code === void 0 ? void 0 : _branch_shShop_sh_shop_code.trim();
                shops.set(id, {
                    value: id,
                    label: shopCode ? "".concat(shopName, " (").concat(shopCode, ")") : shopName
                });
            }
        });
        return Array.from(shops.values());
    }, [
        availableCreateBranches
    ]);
    var createBranchOptions = useMemo(function() {
        return availableCreateBranches.filter(function(branch) {
            return Number(branch === null || branch === void 0 ? void 0 : branch.sh_branch_shid) === Number(createShopId);
        }).map(function(branch) {
            var _branch_sh_branch_code;
            var branchName = branch.sh_branch_name || "สาขา ".concat(branch.sh_branch_id);
            var branchCode = (_branch_sh_branch_code = branch.sh_branch_code) === null || _branch_sh_branch_code === void 0 ? void 0 : _branch_sh_branch_code.trim();
            return {
                value: Number(branch.sh_branch_id),
                label: branchCode ? "".concat(branchName, " (").concat(branchCode, ")") : branchName
            };
        });
    }, [
        availableCreateBranches,
        createShopId
    ]);
    var handleCloseCreateReservation = function() {
        if (creatingReservation) return;
        setCreateReservationShow(false);
        setCreateShopId("");
        setCreateBranchId("");
        dispatch(clearCreateReservation());
    };
    var handleCreateReservation = function() {
        if (!createShopId || !createBranchId || creatingReservation) return;
        dispatch(createReservation({
            shopid: Number(createShopId),
            branchid: Number(createBranchId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        if (createReservationReducer.data && !createReservationReducer.isError) {
            var _selectedBranch_shShop;
            var created = createReservationReducer.data.data || createReservationReducer.data;
            var selectedBranch = availableCreateBranches.find(function(branch) {
                return Number(branch.sh_branch_id) === Number(createBranchId);
            });
            var typeShop = Number((selectedBranch === null || selectedBranch === void 0 ? void 0 : (_selectedBranch_shShop = selectedBranch.shShop) === null || _selectedBranch_shShop === void 0 ? void 0 : _selectedBranch_shShop.sh_shop_typeshop) || 1);
            setCreateReservationShow(false);
            setCreateShopId("");
            setCreateBranchId("");
            dispatch(clearCreateReservation());
            navigate("/report/reservation/edit/".concat(created.rs_reserve_id, "/").concat(typeShop).concat(reservationListQuery));
        }
    }, [
        createReservationReducer.data,
        createReservationReducer.isError
    ]);
    var safeText = function(val) {
        return val && val.trim() !== "" ? val : "-";
    };
    var formatSaleName = function(row) {
        var _row_reserve_salename, _row_reserve_salenickname;
        var name = ((_row_reserve_salename = row.reserve_salename) === null || _row_reserve_salename === void 0 ? void 0 : _row_reserve_salename.trim()) || "";
        var nickname = ((_row_reserve_salenickname = row.reserve_salenickname) === null || _row_reserve_salenickname === void 0 ? void 0 : _row_reserve_salenickname.trim()) || "";
        return name && nickname ? "".concat(name, " (").concat(nickname, ")") : name || nickname || "-";
    };
    var waitDeliveryLocationColumns = [
        {
            name: "บ้าน",
            selector: function(row) {
                return row.sh_branch_village || "";
            },
            cell: function(row) {
                return safeText(row.sh_branch_village);
            }
        },
        {
            name: "เมือง",
            selector: function(row) {
                return row.sh_branch_district || "";
            },
            cell: function(row) {
                return safeText(row.sh_branch_district);
            }
        },
        {
            name: "แขวง",
            selector: function(row) {
                return row.sh_branch_province || "";
            },
            cell: function(row) {
                return safeText(row.sh_branch_province);
            }
        }
    ];
    var truncateText = function(value) {
        var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : TEXT_PREVIEW_LIMIT;
        var text = String(value !== null && value !== void 0 ? value : "").trim();
        return text.length > limit ? "".concat(text.slice(0, limit), "...") : text;
    };
    var getSafeVideoUrl = function(value) {
        try {
            var url = new URL(String(value || "").trim());
            return [
                "http:",
                "https:"
            ].includes(url.protocol) ? url.href : "";
        } catch (e) {
            return "";
        }
    };
    var getReservationBookmarkColor = function(createdAt, status) {
        if (![
            1,
            4,
            7
        ].includes(Number(status))) return null;
        var reservationDate = moment.utc(createdAt);
        if (!reservationDate.isValid()) return null;
        var nowThaiTime = moment.utc().add(7, "hours");
        var latestCycle = nowThaiTime.clone().hour(16).minute(0).second(0).millisecond(0);
        if (nowThaiTime.isBefore(latestCycle)) {
            latestCycle.subtract(1, "day");
        }
        return reservationDate.isSameOrBefore(latestCycle) ? "#dc3545" : "#ffc107";
    };
    var getReserveShopDisplayName = function(row) {
        var shopName = (row === null || row === void 0 ? void 0 : row.rs_reserve_shopname_full) || (row === null || row === void 0 ? void 0 : row.rs_reserve_shopname) || "";
        var branchName = (row === null || row === void 0 ? void 0 : row.rs_reserve_branchname) || "";
        return [
            shopName,
            branchName ? "(".concat(branchName, ")") : ""
        ].filter(Boolean).join(" ").trim();
    };
    var handleCopyTrackingLink = function() {
        var _ref = _async_to_generator(function(event, trackingUrl, reserveCode) {
            var copied, _navigator_clipboard, e, textArea;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        if (!trackingUrl) return [
                            2
                        ];
                        copied = false;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!((_navigator_clipboard = navigator.clipboard) === null || _navigator_clipboard === void 0 ? void 0 : _navigator_clipboard.writeText)) {
                            throw new Error("Clipboard API is unavailable");
                        }
                        return [
                            4,
                            navigator.clipboard.writeText(trackingUrl)
                        ];
                    case 2:
                        _state.sent();
                        copied = true;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        textArea = document.createElement("textarea");
                        textArea.value = trackingUrl;
                        textArea.style.position = "fixed";
                        textArea.style.opacity = "0";
                        try {
                            document.body.appendChild(textArea);
                            textArea.select();
                            copied = document.execCommand("copy");
                        } catch (e) {
                            copied = false;
                        } finally{
                            textArea.remove();
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (copied) {
                            setCopiedTrackingCode(reserveCode || "");
                            setCopyTrackingNotice({
                                open: true,
                                severity: "success",
                                message: "คัดลอกลิงก์ติดตามสินค้าแล้ว"
                            });
                            window.setTimeout(function() {
                                return setCopiedTrackingCode("");
                            }, 1500);
                            return [
                                2
                            ];
                        }
                        setCopyTrackingNotice({
                            open: true,
                            severity: "error",
                            message: "ไม่สามารถคัดลอกลิงก์ติดตามสินค้าได้"
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCopyTrackingLink(event, trackingUrl, reserveCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderNameDateCell = function(name, dateValue) {
        var showTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                maxWidth: "200px",
                minWidth: "120px",
                wordWrap: "break-word"
            },
            className: "text-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: safeText(name)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-secondary",
                    children: showTime ? formatDbDateTime(dateValue) : formatDbDate(dateValue)
                })
            ]
        });
    };
    var baseColumns = [
        {
            name: "รหัสใบจอง",
            selector: function(row) {
                return row.rs_reserve_code;
            },
            center: "true",
            width: "220px",
            cell: function(row) {
                var _row_rs_reserve_deliveryproblemnote;
                var videoUrl = getSafeVideoUrl(row.product_check_video_url);
                var bookmarkColor = getReservationBookmarkColor(row.rs_reserve_credate, row.rs_reserve_status);
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center justify-content-center gap-1",
                    style: {
                        color: "#565DFF",
                        fontWeight: 500,
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/report/reservation/view/".concat(row.rs_reserve_id).concat(reservationListQuery),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: row.rs_reserve_code ? row.rs_reserve_code : "ไม่มีรหัส"
                        }),
                        !waitDeliveryOnly && row.reservation_tracking_url ? /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            title: copiedTrackingCode === row.rs_reserve_code ? "คัดลอกลิงก์แล้ว" : "คัดลอกลิงก์ติดตามสินค้า",
                            "aria-label": "คัดลอกลิงก์ติดตามสินค้า",
                            className: "d-inline-flex align-items-center justify-content-center p-0 border-0",
                            style: {
                                color: copiedTrackingCode === row.rs_reserve_code ? "#198754" : "#565DFF",
                                backgroundColor: copiedTrackingCode === row.rs_reserve_code ? "#d1e7dd" : "#eef0ff",
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                cursor: "pointer",
                                flexShrink: 0,
                                transition: "color 0.2s ease, background-color 0.2s ease"
                            },
                            onClick: function(event) {
                                return handleCopyTrackingLink(event, row.reservation_tracking_url, row.rs_reserve_code);
                            },
                            children: /*#__PURE__*/ _jsx(LinkOutlinedIcon, {
                                fontSize: "small"
                            })
                        }) : null,
                        row.rs_reserve_deliveryproblemid || ((_row_rs_reserve_deliveryproblemnote = row.rs_reserve_deliveryproblemnote) === null || _row_rs_reserve_deliveryproblemnote === void 0 ? void 0 : _row_rs_reserve_deliveryproblemnote.trim()) ? /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            title: "ปัญหาการส่งสินค้า",
                            "aria-label": "ปัญหาการส่งสินค้า",
                            className: "d-inline-flex align-items-center justify-content-center p-0 border-0",
                            style: {
                                color: "#dc3545",
                                backgroundColor: "#ffe3e3",
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                cursor: "pointer",
                                flexShrink: 0
                            },
                            onClick: function(event) {
                                event.preventDefault();
                                event.stopPropagation();
                                setDeliveryProblemModal({
                                    show: true,
                                    problem: row.rs_reserve_delivery_problem_name || "",
                                    note: row.rs_reserve_deliveryproblemnote || ""
                                });
                            },
                            children: /*#__PURE__*/ _jsx(ReportProblemOutlinedIcon, {
                                fontSize: "small"
                            })
                        }) : null,
                        bookmarkColor ? /*#__PURE__*/ _jsx(BookmarkIcon, {
                            fontSize: "small",
                            titleAccess: bookmarkColor === "#dc3545" ? "อยู่ก่อนรอบ 16:00 ล่าสุด" : "อยู่หลังรอบ 16:00 ล่าสุด",
                            style: {
                                color: bookmarkColor,
                                flexShrink: 0
                            }
                        }) : null,
                        videoUrl ? /*#__PURE__*/ _jsx("a", {
                            href: videoUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            title: "เปิดวิดีโอการแพ็คสินค้า",
                            className: "d-inline-flex align-items-center",
                            style: {
                                color: "#dc3545"
                            },
                            onClick: function(event) {
                                return event.stopPropagation();
                            },
                            children: /*#__PURE__*/ _jsx(VideocamOutlinedIcon, {
                                fontSize: "small"
                            })
                        }) : null
                    ]
                });
            }
        },
        {
            name: "วันที่จอง",
            selector: function(row) {
                return row.rs_reserve_credate;
            },
            center: "true",
            width: "170px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.rs_reserve_credate && row.rs_reserve_credate != "" && row.rs_reserve_credate != null ? formatDbDateTime(row.rs_reserve_credate) : "-"
                });
            }
        },
        {
            name: "ชื่อร้าน",
            selector: function(row) {
                return row.rs_reserve_shopname;
            },
            width: "250px",
            center: "true",
            cell: function(row) {
                var fullShopName = getReserveShopDisplayName(row);
                var hasMore = fullShopName.length > TEXT_PREVIEW_LIMIT;
                return /*#__PURE__*/ _jsxs("div", {
                    style: {
                        maxWidth: waitDeliveryOnly ? "100%" : "250px",
                        width: waitDeliveryOnly ? "100%" : undefined,
                        minWidth: "100px",
                        wordWrap: "break-word",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                    },
                    className: fullShopName ? "text-left" : "text-center",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                flex: 1
                            },
                            children: safeText(truncateText(fullShopName))
                        }),
                        hasMore && /*#__PURE__*/ _jsx(Button, {
                            variant: "outline-primary",
                            size: "sm",
                            className: "p-0 ms-auto d-inline-flex align-items-center justify-content-center rounded-circle",
                            title: "ดูชื่อร้านเต็ม",
                            "aria-label": "ดูชื่อร้านเต็ม",
                            style: {
                                width: "26px",
                                height: "26px",
                                minWidth: "26px"
                            },
                            onClick: function() {
                                return setShopNameModal({
                                    show: true,
                                    text: fullShopName
                                });
                            },
                            children: /*#__PURE__*/ _jsx(MoreHorizIcon, {
                                fontSize: "small"
                            })
                        })
                    ]
                });
            }
        },
        {
            name: "ประเภทร้านค้า",
            selector: function(row) {
                var _row_shShop, _row_shShop1, _row_shShop2;
                return (row === null || row === void 0 ? void 0 : (_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_typeshop) == 1 && "RT" || (row === null || row === void 0 ? void 0 : (_row_shShop1 = row.shShop) === null || _row_shShop1 === void 0 ? void 0 : _row_shShop1.sh_shop_typeshop) == 2 && "WT" || (row === null || row === void 0 ? void 0 : (_row_shShop2 = row.shShop) === null || _row_shShop2 === void 0 ? void 0 : _row_shShop2.sh_shop_typeshop) == 3 && "MT";
            },
            center: "true",
            width: "150px"
        },
        {
            name: "จำนวนชิ้นที่จอง",
            selector: function(row) {
                return integerText(row.rs_reserve_amount);
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    children: integerText(row.rs_reserve_amount)
                });
            },
            center: "true",
            width: "150px"
        },
        {
            name: "จำนวนชิ้นที่ส่งจริง",
            selector: function(row) {
                return integerText(row.rs_reserve_stamount);
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    children: integerText(row.rs_reserve_stamount)
                });
            },
            center: "true",
            width: "150px"
        },
        {
            name: "เซลล์",
            selector: function(row) {
                return formatSaleName(row);
            },
            //width: "200px",
            center: "true",
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        maxWidth: "200px",
                        minWidth: "100px",
                        wordWrap: "break-word"
                    },
                    className: row.reserve_salename && row.reserve_salename != "" ? "text-left" : "text-center",
                    children: formatSaleName(row)
                });
            }
        },
        {
            name: "วันที่เซลล์ติดต่อ",
            selector: function(row) {
                return row.rs_reserve_saledate;
            },
            center: "true",
            width: "170px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.rs_reserve_saledate && row.rs_reserve_saledate != "" && row.rs_reserve_saledate != null ? formatDbDateTime(row.rs_reserve_saledate) : "-"
                });
            }
        },
        {
            name: "สถานะเซลล์ติดต่อลูกค้า",
            selector: function(row) {
                return row.rs_reserve_salestatus;
            },
            center: "true",
            width: "190px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(StatusContactSale, {
                    reportId: row.rs_reserve_id,
                    setReportId: setReportId,
                    statusId: row.rs_reserve_salestatus,
                    setStatusId: setStatusId,
                    statusName: row.rs_reserve_salestatus_text,
                    reserveCode: row.rs_reserve_code,
                    setReserveCode: setReserveCode,
                    resetNote: row.rs_reserve_resetnote,
                    setReserveResetNote: setReserveResetNote,
                    branchCreditStatus: row.sh_branch_creditstatus,
                    setReserveBranchCreditStatus: setReserveBranchCreditStatus,
                    handleOpen: handleChgSalesShow,
                    readOnly: isWarehouseRole
                });
            }
        },
        {
            name: "กำลังจัดสินค้า",
            selector: function(row) {
                return row.rs_reserve_organizedate;
            },
            sortable: true,
            sortField: "rs_reserve_organizedate",
            center: "true",
            width: "170px",
            cell: function(row) {
                return renderNameDateCell(row.rs_reserve_organizename, row.rs_reserve_organizedate);
            }
        },
        {
            name: "ตรวจสอบสินค้า",
            selector: function(row) {
                return row.rs_reserve_pdcheckedate;
            },
            sortable: true,
            sortField: "rs_reserve_pdcheckedate",
            center: "true",
            width: "170px",
            cell: function(row) {
                return renderNameDateCell(row.rs_reserve_pdcheckename, row.rs_reserve_pdcheckedate);
            }
        },
        {
            name: "รอส่งสินค้า",
            selector: function(row) {
                return row.rs_reserve_waitdate;
            },
            sortable: true,
            sortField: "rs_reserve_waitdate",
            center: "true",
            width: "170px",
            cell: function(row) {
                return renderNameDateCell(row.rs_reserve_waitname, row.rs_reserve_waitdate);
            }
        },
        {
            name: "ส่งสินค้าแล้ว",
            selector: function(row) {
                return row.rs_reserve_approvedate;
            },
            sortable: true,
            sortField: "rs_reserve_approvedate",
            center: "true",
            width: "170px",
            cell: function(row) {
                return renderNameDateCell(row.rs_reserve_approvename, row.rs_reserve_approvedate);
            }
        },
        {
            name: "วันที่จัดสินค้า",
            selector: function(row) {
                return row.rs_reserve_dateorganize;
            },
            sortable: true,
            sortField: "rs_reserve_dateorganize",
            center: "true",
            width: "150px",
            cell: function(row) {
                return row.rs_reserve_dateorganize ? formatDbDate(row.rs_reserve_dateorganize) : "-";
            }
        },
        {
            name: "คาดว่าจัดส่งสินค้า",
            selector: function(row) {
                return row.rs_reserve_datedelivery;
            },
            sortable: true,
            sortField: "rs_reserve_datedelivery",
            center: "true",
            width: "150px",
            cell: function(row) {
                return row.rs_reserve_datedelivery ? formatDbDate(row.rs_reserve_datedelivery) : "-";
            }
        },
        {
            name: "วันที่ส่งสินค้าจริง",
            selector: function(row) {
                return row.rs_reserve_datepass;
            },
            sortable: true,
            sortField: "rs_reserve_datepass",
            center: "true",
            width: "150px",
            cell: function(row) {
                return renderNameDateCell(row.rs_reserve_approvename, row.rs_reserve_datepass, false);
            }
        },
        {
            name: "วันที่ชำระเงิน",
            selector: function(row) {
                return row.rs_reserve_paydate;
            },
            sortable: true,
            sortField: "rs_reserve_paydate",
            center: "true",
            width: "170px",
            cell: function(row) {
                return renderNameDateCell(row.rs_reserve_payname, row.rs_reserve_paydate, false);
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.rs_reserve_status;
            },
            center: "true",
            width: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(StatusReservation, {
                    reportId: row.rs_reserve_id,
                    setReportListId: setReportListId,
                    statusId: row.rs_reserve_status,
                    setStListId: setStListId,
                    statusName: row.rs_reserve_status_text,
                    reserveCode: row.rs_reserve_code,
                    setReserveCodeList: setReserveCodeList,
                    statusSale: row.rs_reserve_salestatus,
                    setStatusSale: setStatusSale,
                    handleOpen: handleChgListShow,
                    reservationManagementOnly: reservationManagementOnly
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.rs_reserve_id;
            },
            cell: function(row) {
                var _row_rs_reserve_cancelnote, _row_shShop;
                return /*#__PURE__*/ _jsxs(Stack, {
                    direction: "horizontal",
                    gap: 1,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: [
                        ((_row_rs_reserve_cancelnote = row.rs_reserve_cancelnote) === null || _row_rs_reserve_cancelnote === void 0 ? void 0 : _row_rs_reserve_cancelnote.trim()) ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "หมายเหตุ",
                            onClick: function() {
                                return setCancelNoteModal({
                                    show: true,
                                    text: row.rs_reserve_cancelnote.trim()
                                });
                            },
                            children: /*#__PURE__*/ _jsx(NotesIcon, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        }) : null,
                        !(Number(row.rs_reserve_status) === 1 && Number(row.rs_reserve_salestatus) === 2) ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "แก้ไขรายการ",
                            href: "/report/reservation/edit/".concat(row.rs_reserve_id, "/").concat(row === null || row === void 0 ? void 0 : (_row_shShop = row.shShop) === null || _row_shShop === void 0 ? void 0 : _row_shShop.sh_shop_typeshop).concat(reservationListQuery),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#FFF1DD",
                                    color: "#FFA319",
                                    padding: 5
                                }
                            })
                        }) : null,
                        !(isWarehouseRole && Number(row.rs_reserve_status) === 1) ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "PDF ใบจอง",
                            onClick: function() {
                                return handlePrintPdf(row.rs_reserve_id, DOC_TYPE_PENDING);
                            },
                            children: /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                                style: {
                                    borderRadius: 40,
                                    fontSize: 30,
                                    background: "#F3E8FF",
                                    color: "#7E22CE",
                                    padding: 5
                                }
                            })
                        }) : null,
                        !isSalesRole && [
                            4,
                            7,
                            5,
                            2,
                            6
                        ].includes(parseInt(row.rs_reserve_status, 10)) ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "PDF ใบจัดสินค้า",
                            onClick: function() {
                                return handlePrintPdf(row.rs_reserve_id, DOC_TYPE_PICKING);
                            },
                            children: /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                                style: {
                                    borderRadius: 40,
                                    fontSize: 30,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        }) : null,
                        [
                            7,
                            5,
                            2,
                            6
                        ].includes(parseInt(row.rs_reserve_status, 10)) ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "PDF ใบส่งสินค้า",
                            onClick: function() {
                                return handlePrintPdf(row.rs_reserve_id, DOC_TYPE_DELIVERY);
                            },
                            children: /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                                style: {
                                    borderRadius: 40,
                                    fontSize: 30,
                                    background: "rgb(229, 227, 255)",
                                    color: "#0d6efd",
                                    padding: 5
                                }
                            })
                        }) : null,
                        (!isSalesRole || userRoleId === 4) && [
                            5,
                            2,
                            6
                        ].includes(parseInt(row.rs_reserve_status, 10)) ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "PDF ใบปะหน้า",
                            onClick: function() {
                                return handlePrintPdf(row.rs_reserve_id, DOC_TYPE_SHIPPING_LABEL);
                            },
                            children: /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                                style: {
                                    borderRadius: 40,
                                    fontSize: 30,
                                    background: "#F1E4D7",
                                    color: "#8B5E3C",
                                    padding: 5
                                }
                            })
                        }) : null,
                        [
                            7,
                            5,
                            2,
                            6
                        ].includes(parseInt(row.rs_reserve_status, 10)) && Number(row.rs_reserve_cannot_send_count || 0) > 0 ? /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            className: "m-0 p-0",
                            title: "PDF ใบสินค้าไม่พร้อมจัดส่ง",
                            onClick: function() {
                                return handlePrintPdf(row.rs_reserve_id, DOC_TYPE_NO_DELIVERY);
                            },
                            children: /*#__PURE__*/ _jsx(PictureAsPdfIcon, {
                                style: {
                                    borderRadius: 40,
                                    fontSize: 30,
                                    background: "#FCE7F3",
                                    color: "#BE185D",
                                    padding: 5
                                }
                            })
                        }) : null
                    ]
                });
            },
            center: "true",
            width: "230px"
        },
        {
            name: "ราคาจองรวม",
            selector: function(row) {
                return Number(row.rs_reserve_net || 0);
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-end",
                    children: NumberFormat(row.rs_reserve_net || 0, 2)
                });
            },
            right: "true",
            width: "150px"
        },
        {
            name: "ราคาส่งจริงรวม",
            selector: function(row) {
                return Number(row.rs_reserve_stnet || 0);
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-end",
                    children: NumberFormat(row.rs_reserve_stnet || 0, 2)
                });
            },
            right: "true",
            width: "150px"
        }
    ];
    var pinnedColumnOrder = waitDeliveryOnly ? [
        "สถานะ",
        "ชื่อร้าน",
        "รหัสใบจอง"
    ] : [
        "จัดการ",
        "สถานะเซลล์ติดต่อลูกค้า",
        "สถานะ",
        "รหัสใบจอง"
    ];
    var visibleBaseColumns = waitDeliveryOnly ? baseColumns.flatMap(function(column) {
        return column.name === "รอส่งสินค้า" ? [
            column
        ].concat(_to_consumable_array(waitDeliveryLocationColumns)) : [
            column
        ];
    }).filter(function(column) {
        return !WAIT_DELIVERY_HIDDEN_COLUMNS.has(column.name);
    }).map(function(column) {
        var columnWithoutFixedWidth = _object_spread({}, column);
        delete columnWithoutFixedWidth.width;
        return _object_spread({}, columnWithoutFixedWidth, WAIT_DELIVERY_COLUMN_LAYOUT[column.name] || {
            grow: 1,
            minWidth: "120px"
        });
    }) : reservationManagementOnly ? baseColumns.filter(function(column) {
        return !RESERVATION_MANAGEMENT_HIDDEN_COLUMNS.has(column.name);
    }) : baseColumns;
    var columns = _to_consumable_array(pinnedColumnOrder.map(function(columnName) {
        return visibleBaseColumns.find(function(column) {
            return column.name === columnName;
        });
    }).filter(Boolean)).concat(_to_consumable_array(visibleBaseColumns.filter(function(column) {
        return !pinnedColumnOrder.includes(column.name);
    })));
    var getFilterValue = function(value) {
        return value && parseInt(value, 10) > 0 ? parseInt(value, 10) : "";
    };
    var getFormattedDate = function(date) {
        return date ? moment(date).format("YYYY-MM-DD") : "";
    };
    var getData = function() {
        var statusList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, saleStatusList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        setIsLoading(true);
        var requestedStatus = waitDeliveryOnly ? WAIT_DELIVERY_STATUS : statusList;
        var requestedSaleStatus = waitDeliveryOnly ? 0 : saleStatusList;
        dispatch(getAllDataRsreserve(_object_spread({
            status: getFilterValue(requestedStatus),
            salestatus: getFilterValue(requestedSaleStatus),
            pageId: pageId,
            pageSize: pageSize,
            searchtext: filterText
        }, shopId && {
            shopid: parseInt(shopId, 10)
        }, !waitDeliveryOnly && saleId && {
            saleid: parseInt(saleId, 10)
        }, !waitDeliveryOnly && adminId && {
            adminid: parseInt(adminId, 10)
        }, !waitDeliveryOnly && shopTypeId && {
            typeshop: parseInt(shopTypeId, 10)
        }, sDate && {
            startdate: getFormattedDate(sDate)
        }, eDate && {
            enddate: getFormattedDate(eDate)
        }, waitDeliveryOnly && {
            dateField: "rs_reserve_waitdate"
        }, (sortModel === null || sortModel === void 0 ? void 0 : sortModel.sortField) && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(getAllDataRsreserveReducer.isFetching || getDataRsreserveByIdReducer.isFetching || getDataCatalogByIdReducer.isFetching || allSetUserReducer.isFetching || getShopReducer.isFetching);
        setLoading(getAllDataRsreserveReducer.isFetching);
        if (getAllDataRsreserveReducer.data && !getAllDataRsreserveReducer.isError) {
            var responseData = getAllDataRsreserveReducer.data.data;
            var rows = Array.isArray(responseData) ? responseData : (responseData === null || responseData === void 0 ? void 0 : responseData.data) || [];
            var pagination = Array.isArray(responseData) ? {} : (responseData === null || responseData === void 0 ? void 0 : responseData.pagination) || {};
            var responseStatusCounts = Array.isArray(responseData) ? {} : (responseData === null || responseData === void 0 ? void 0 : responseData.status_counts) || {};
            var responseDeliveryProblemOptions = Array.isArray(responseData) ? [] : (responseData === null || responseData === void 0 ? void 0 : responseData.delivery_problem_options) || [];
            setTableData(rows);
            setFilteredItems(rows);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || rows.length);
            setStatusCounts(responseStatusCounts);
            setDeliveryProblemOptions(responseDeliveryProblemOptions);
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var data = rows;
            var sharr = [];
            var shopSet = new Set();
            data.forEach(function(ele) {
                if (!shopSet.has(ele.rs_reserve_shid)) {
                    shopSet.add(ele.rs_reserve_shid);
                    sharr.push({
                        value: ele.rs_reserve_shid,
                        label: "".concat(ele === null || ele === void 0 ? void 0 : ele.rs_reserve_shopname, " (").concat(ele === null || ele === void 0 ? void 0 : ele.rs_reserve_branchname, ")")
                    });
                }
            });
            setOptionShop(_to_consumable_array(all).concat(_to_consumable_array(sharr)));
        }
        if (getDataRsreserveByIdReducer.data && !getDataRsreserveByIdReducer.isError) {
            var datas = getDataRsreserveByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (dataWithReplacements && dataWithReplacements[0]) {
                setReservationData(dataWithReplacements[0]);
            } else if (dataWithReplacements) {
                setReservationData(dataWithReplacements);
            }
        }
        if (getDataCatalogByIdReducer.data && !getDataCatalogByIdReducer.isError) {
            var datas2 = getDataCatalogByIdReducer.data.data;
            if (!datas2) {
                return navigate("/404", {
                    replace: true
                });
            }
            setDataItem(sortReservationCatalogItems(datas2));
        }
        if (allSetUserReducer.data) {
            var op = allSetUserReducer.data.data;
            var arr = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var arrt5 = [];
            var arrt3 = [];
            op.filter(function(v) {
                return v.sys_user_role_id === 1;
            }).map(function(ele) {
                return arrt5.push({
                    value: ele.sys_user_id,
                    label: "".concat(ele.sys_user_fullname, " ( ").concat(ele.sys_user_nname, " ) ")
                });
            });
            setOptionAdmin(_to_consumable_array(arr).concat(_to_consumable_array(arrt5)));
            op.filter(function(v) {
                return v.sys_user_role_id === 3 && v.sys_user_status === "Enable";
            }).map(function(ele) {
                return arrt3.push({
                    value: ele.sys_user_id,
                    label: "".concat(ele.sys_user_fullname, " ( ").concat(ele.sys_user_nname, " ) ")
                });
            });
            setOptionSale(_to_consumable_array(arr).concat(_to_consumable_array(arrt3)));
        }
        if (getShopReducer.data) {
            var _getShopReducer_data;
            var all1 = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var branches = (getShopReducer === null || getShopReducer === void 0 ? void 0 : (_getShopReducer_data = getShopReducer.data) === null || _getShopReducer_data === void 0 ? void 0 : _getShopReducer_data.data) || [];
            var shopSet1 = new Set();
            var sharr1 = [];
            branches.forEach(function(branch) {
                var _branch_shShop;
                var value = branch === null || branch === void 0 ? void 0 : branch.sh_branch_shid;
                var shopName = branch === null || branch === void 0 ? void 0 : (_branch_shShop = branch.shShop) === null || _branch_shShop === void 0 ? void 0 : _branch_shShop.sh_shop_name;
                var branchName = branch === null || branch === void 0 ? void 0 : branch.sh_branch_name;
                if (!value || shopSet1.has(value)) {
                    return;
                }
                shopSet1.add(value);
                sharr1.push({
                    value: value,
                    label: branchName ? "".concat(shopName, " (").concat(branchName, ")") : shopName
                });
            });
            setOptionShop(_to_consumable_array(all1).concat(_to_consumable_array(sharr1)));
        }
    }, [
        getAllDataRsreserveReducer,
        getDataRsreserveByIdReducer,
        getDataCatalogByIdReducer,
        allSetUserReducer,
        getShopReducer
    ]);
    useEffect(function() {
        setFilteredItems(tableData);
    }, [
        tableData
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            setExcelData(filteredItems.filter(function(item) {
                return item.rs_reserve_id && item.rs_reserve_id != "" && item.rs_reserve_id > 0;
            }).map(function(item, index) {
                return {
                    reservation_no: index + 1,
                    reservation_code: item.rs_reserve_code,
                    doc_date_create: item.rs_reserve_credate && item.rs_reserve_credate != null && item.rs_reserve_credate != "" ? formatDbDateTime(item.rs_reserve_credate) : "-",
                    shop_name: item.rs_reserve_shopname && item.rs_reserve_shopname != null && item.rs_reserve_shopname != "" ? filterTextAndNum(item.rs_reserve_shopname) : "-",
                    branch_name: item.rs_reserve_branchname && item.rs_reserve_branchname != null && item.rs_reserve_branchname != "" ? filterTextAndNum(item.rs_reserve_branchname) : "-",
                    sales_name: item.rs_reserve_salename && item.rs_reserve_salename != null && item.rs_reserve_salename != "" ? filterTextAndNum(item.rs_reserve_salename) : "-",
                    date_contact: item.rs_reserve_saledate && item.rs_reserve_saledate != null && item.rs_reserve_saledate != "" ? formatDbDateTime(item.rs_reserve_saledate) : "-",
                    status_contact: item.rs_reserve_salestatus_text && item.rs_reserve_salestatus_text != null && item.rs_reserve_salestatus_text != "" ? filterTextAndNum(item.rs_reserve_salestatus_text) : "-",
                    admin_name: item.reserve_adminname && item.reserve_adminname != null && item.reserve_adminname != "" ? filterTextAndNum(item.reserve_adminname) : "-",
                    date_approved: item.rs_reserve_approvedate && item.rs_reserve_approvedate != null && item.rs_reserve_approvedate != "" ? formatDbDateTime(item.rs_reserve_approvedate) : "-",
                    pay_date: item.rs_reserve_paydate && item.rs_reserve_paydate != null && item.rs_reserve_paydate != "" ? formatDbDate(item.rs_reserve_paydate) : "-",
                    status: item.rs_reserve_status_text && item.rs_reserve_status_text != null && item.rs_reserve_status_text != "" ? filterTextAndNum(item.rs_reserve_status_text) : "-"
                };
            }));
        } else {
            setExcelData([]);
        }
    }, [
        filteredItems
    ]);
    useEffect(function() {
        if (!waitDeliveryOnly) {
            dispatch(allSetUser({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        dispatch(getShop({}, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!waitDeliveryOnly && canCreateReservation) {
            dispatch(getReservationCreateShop({}, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    useEffect(function() {
        getData(statusCt, saleStatusCt);
    }, [
        statusCt,
        saleStatusCt,
        pageId,
        pageSize,
        sortModel,
        filterText,
        shopId,
        saleId,
        adminId,
        sDate,
        eDate,
        shopTypeId
    ]);
    useEffect(function() {
        if (reData) {
            getData(statusCt, saleStatusCt);
            setReData(false);
        }
    }, [
        reData
    ]);
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
        setPageId(1);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        if (!field) {
            return;
        }
        setSortModel({
            sortField: field,
            sortValue: sortDirection
        });
        setPageId(1);
    };
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        documentTitle: "".concat(getPdfDocumentName(printDocType), "_").concat(moment().format("DDMMYYYYHHmmss")),
        content: function() {
            return componentRef.current;
        }
    });
    if (!window.Buffer) window.Buffer = Buffer;
    var handleDownload = function() {
        var _ref = _async_to_generator(function() {
            var documentName, blob, fileName, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        documentName = getPdfDocumentName(printDocType);
                        return [
                            4,
                            pdf(printDocType === DOC_TYPE_SHIPPING_LABEL ? /*#__PURE__*/ _jsx(ShippingLabelDocument, {
                                dataFrom: reservationData
                            }) : /*#__PURE__*/ _jsx(ContractDocument, {
                                dataFrom: reservationData,
                                dataItem: dataItem,
                                typeDocPrint: 1,
                                docType: printDocType
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        fileName = "".concat(documentName, "_").concat(moment().format("DDMMYYYYHHmmss"), ".pdf");
                        saveAs(blob, fileName);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                        alert("ไม่สามารถสร้างไฟล์ PDF ได้");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePrintPdf = function() {
        var _ref = _async_to_generator(function() {
            var rowId, docType;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        rowId = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0, docType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : DOC_TYPE_PICKING;
                        setDataItem([]);
                        setReservationData({});
                        setPrintDocType(docType);
                        if (!(rowId && rowId > 0)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            dispatch(getDataRsreserveById({
                                rsreserveid: parseInt(rowId, 10)
                            }, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 1:
                        _state.sent();
                        if (!(docType !== DOC_TYPE_SHIPPING_LABEL)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(getDataCatalogById({
                                rsreserveid: parseInt(rowId, 10)
                            }, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        setOpenPrint(true);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePrintPdf() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        if (openPrint && reservationData && Object.keys(reservationData).length > 0 && (printDocType === DOC_TYPE_SHIPPING_LABEL || dataItem && dataItem.length > 0)) {
            handleDownload();
            setOpenPrint(false);
        }
    }, [
        reservationData,
        dataItem,
        openPrint,
        printDocType
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: waitDeliveryOnly ? "รายการใบจอง (รอส่งสินค้า)" : reservationManagementOnly ? "จัดการใบจอง" : "รายงานการจอง"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex align-items-center justify-content-between gap-2 mb-2",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-24",
                                children: waitDeliveryOnly ? "รายการใบจอง (รอส่งสินค้า)" : reservationManagementOnly ? "จัดการใบจอง" : "รายการการจอง"
                            }),
                            !waitDeliveryOnly && canCreateReservation ? /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: "btn-st-3 d-flex align-items-center gap-1",
                                onClick: function() {
                                    return setCreateReservationShow(true);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(AddIcon, {
                                        fontSize: "small"
                                    }),
                                    "สร้าง"
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    waitDeliveryOnly ? /*#__PURE__*/ _jsx(Row, {
                        className: "mb-3",
                        children: /*#__PURE__*/ _jsx(Col, {
                            xl: 3,
                            md: 6,
                            xs: 12,
                            children: /*#__PURE__*/ _jsx(Card, {
                                className: "border-0 h-100",
                                style: {
                                    backgroundColor: "#fff7e5",
                                    color: "#f59e0b"
                                },
                                children: /*#__PURE__*/ _jsxs(CardBody, {
                                    className: "d-flex align-items-center justify-content-between gap-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-18 fw-semibold mb-2",
                                                    children: "จำนวนใบจอง"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-14 mb-2",
                                                    children: "สถานะรอส่งสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-28 fw-bold",
                                                    children: [
                                                        integerText(totalAmount),
                                                        " รายการ"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "d-flex align-items-center justify-content-center flex-shrink-0",
                                            style: {
                                                width: 56,
                                                height: 56,
                                                borderRadius: "50%",
                                                backgroundColor: "rgba(245, 158, 11, 0.15)"
                                            },
                                            children: /*#__PURE__*/ _jsx(LocalShippingOutlinedIcon, {
                                                sx: {
                                                    fontSize: 32
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }) : null,
                    !waitDeliveryOnly ? /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsxs(Col, {
                                lg: 6,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-1 fw-semibold",
                                        children: "สถานะเซลล์"
                                    }),
                                    /*#__PURE__*/ _jsxs(Nav, {
                                        variant: "pills",
                                        activeKey: tabSaleStatus,
                                        onSelect: function(selectedKey) {
                                            setTabSaleStatus(selectedKey);
                                            setSaleStatusCt(selectedKey ? parseInt(selectedKey, 10) : 0);
                                            setPageId(1);
                                        },
                                        className: "mb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "0",
                                                    children: [
                                                        "ทั้งหมด (",
                                                        statusCountText(statusCounts, "sale_status", 0),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "1",
                                                    children: [
                                                        "รอติดต่อ (",
                                                        statusCountText(statusCounts, "sale_status", 1),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "2",
                                                    children: [
                                                        "ยืนยันแล้ว (",
                                                        statusCountText(statusCounts, "sale_status", 2),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "3",
                                                    children: [
                                                        "ยกเลิก (",
                                                        statusCountText(statusCounts, "sale_status", 3),
                                                        ")"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Col, {
                                lg: 6,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mb-1 fw-semibold",
                                        children: "สถานะ"
                                    }),
                                    /*#__PURE__*/ _jsxs(Nav, {
                                        variant: "pills",
                                        activeKey: tabStatus,
                                        onSelect: function(selectedKey) {
                                            setTabStatus(selectedKey);
                                            setStatusCt(selectedKey ? parseInt(selectedKey, 10) : 0);
                                            setPageId(1);
                                        },
                                        className: "mb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "0",
                                                    children: [
                                                        "ทั้งหมด (",
                                                        statusCountText(statusCounts, "reserve_status", 0),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "1",
                                                    children: [
                                                        "รอยืนยัน (",
                                                        statusCountText(statusCounts, "reserve_status", 1),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "4",
                                                    children: [
                                                        "กำลังจัดสินค้า (",
                                                        statusCountText(statusCounts, "reserve_status", 4),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "7",
                                                    children: [
                                                        "ตรวจสอบสินค้า (",
                                                        statusCountText(statusCounts, "reserve_status", 7),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "5",
                                                    children: [
                                                        "รอส่งสินค้า (",
                                                        statusCountText(statusCounts, "reserve_status", 5),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "2",
                                                    children: [
                                                        "ส่งสินค้าแล้ว (",
                                                        statusCountText(statusCounts, "reserve_status", 2),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "6",
                                                    children: [
                                                        "ชำระเงินแล้ว (",
                                                        statusCountText(statusCounts, "reserve_status", 6),
                                                        ")"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Nav.Item, {
                                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                                    className: "tc-13 nav-danger",
                                                    eventKey: "3",
                                                    children: [
                                                        "ยกเลิก (",
                                                        statusCountText(statusCounts, "reserve_status", 3),
                                                        ")"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsxs(CardBody, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Row, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                lg: 1,
                                                className: "mb-2",
                                                children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                                    data: excelData,
                                                    filename: "reservation_" + moment().format("YYYYMMDDHHmmss")
                                                })
                                            }),
                                            !waitDeliveryOnly ? /*#__PURE__*/ _jsx(Col, {
                                                lg: 2,
                                                md: 6,
                                                children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                                    value: dateRange,
                                                    onChange: handleDateRangeChange
                                                })
                                            }) : null,
                                            /*#__PURE__*/ _jsx(Col, {
                                                lg: waitDeliveryOnly ? 6 : 5,
                                                className: "mb-2",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "row ml-2",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-3 col-md-12",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                className: "mb-2",
                                                                children: waitDeliveryOnly ? "ค้นหาตามช่วงวันที่รอส่งสินค้า" : "ค้นหาตามช่วงวันที่สั่ง"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-4 col-md-12",
                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                selected: sDate,
                                                                onChange: function(date) {
                                                                    setDateRange("custom");
                                                                    setSDate(date);
                                                                    setPageId(1);
                                                                },
                                                                dateFormat: "dd-MM-yyyy",
                                                                className: "form-control px-2 mb-2",
                                                                isClearable: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-1 col-md-12",
                                                            children: /*#__PURE__*/ _jsx("center", {
                                                                className: "mb-2",
                                                                children: "ถึง"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-4 col-md-12",
                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                selected: eDate,
                                                                onChange: function(date) {
                                                                    setDateRange("custom");
                                                                    setEDate(date);
                                                                    setPageId(1);
                                                                },
                                                                dateFormat: "dd-MM-yyyy",
                                                                className: "form-control px-2 mb-2",
                                                                isClearable: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                lg: waitDeliveryOnly ? 5 : 4,
                                                children: /*#__PURE__*/ _jsx(Stack, {
                                                    direction: "horizontal",
                                                    gap: 2,
                                                    children: /*#__PURE__*/ _jsx("input", {
                                                        type: "text",
                                                        className: "form-control",
                                                        placeholder: waitDeliveryOnly ? "ค้นหาเลขที่ใบจอง, ชื่อร้าน, สาขา" : "ค้นหาเลขที่ใบจอง, ชื่อร้าน, สาขา, ชื่อเซลล์, ชื่อแอดมิน",
                                                        value: filterText,
                                                        onChange: function(e) {
                                                            setFilterText(e.target.value);
                                                            setPageId(1);
                                                        }
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "pt-1 px-0",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "row",
                                            children: [
                                                !waitDeliveryOnly ? /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3 col-md-6",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 p-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ค้นหาร้านค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, _object_spread({
                                                                as: "select",
                                                                className: "w-100 select-st-3",
                                                                placeholder: "ค้นหาร้านค้า",
                                                                options: optionShop,
                                                                defaultValue: 0,
                                                                value: optionShop.find(function(opt) {
                                                                    return opt.value === shopId;
                                                                }) || "",
                                                                onChange: function(e) {
                                                                    setShopId(e ? e.value : "");
                                                                    setPageId(1);
                                                                },
                                                                isClearable: true
                                                            }, selectMenuPortalProps))
                                                        ]
                                                    })
                                                }) : null,
                                                !waitDeliveryOnly ? /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3 col-md-6",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ค้นหาเซลล์ที่ดูแล"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, _object_spread({
                                                                as: "select",
                                                                className: "w-100 select-st-3",
                                                                placeholder: "ค้นหาเซลล์ที่ดูแล",
                                                                options: optionSale,
                                                                value: optionSale.find(function(opt) {
                                                                    return opt.value === saleId;
                                                                }) || "",
                                                                onChange: function(e) {
                                                                    setSaleId(e ? e.value : "");
                                                                    setPageId(1);
                                                                },
                                                                isClearable: true
                                                            }, selectMenuPortalProps))
                                                        ]
                                                    })
                                                }) : null,
                                                !waitDeliveryOnly ? /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3 col-md-6",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ค้นหาแอดมิน"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, _object_spread({
                                                                as: "select",
                                                                className: "w-100 select-st-3",
                                                                placeholder: "ค้นหาแอดมิน",
                                                                options: optionAdmin,
                                                                value: optionAdmin.find(function(opt) {
                                                                    return opt.value === adminId;
                                                                }) || "",
                                                                onChange: function(e) {
                                                                    setAdminId(e ? e.value : "");
                                                                    setPageId(1);
                                                                },
                                                                isClearable: true
                                                            }, selectMenuPortalProps))
                                                        ]
                                                    })
                                                }) : null,
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "col-xl-3 col-md-6",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-2 form-st-3 p-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1 z-3",
                                                                children: "ค้นหาประเภทร้านค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Select, _object_spread({
                                                                className: "w-100 select-st-3 z-2",
                                                                placeholder: "ค้นหาประเภทร้านค้า",
                                                                options: optionShopType,
                                                                value: optionShopType.find(function(opt) {
                                                                    return opt.value === shopTypeId;
                                                                }) || "",
                                                                onChange: function(e) {
                                                                    setShopTypeId(e ? e.value : "");
                                                                    setPageId(1);
                                                                },
                                                                isClearable: true
                                                            }, selectMenuPortalProps))
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    overflowX: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("style", {
                                        children: "\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n              .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n                position: sticky !important;\n                left: 0 !important;\n                z-index: 3 !important;\n                background-color: #ffffff !important;\n                box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08) !important;\n              }\n\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n              .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n                position: sticky !important;\n                left: 150px !important;\n                z-index: 3 !important;\n                background-color: #ffffff !important;\n                box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08) !important;\n              }\n\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n              .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n                position: sticky !important;\n                left: 340px !important;\n                z-index: 3 !important;\n                background-color: #ffffff !important;\n                box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08) !important;\n              }\n\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n              .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(4) {\n                position: sticky !important;\n                left: 490px !important;\n                z-index: 3 !important;\n                background-color: #ffffff !important;\n                box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08) !important;\n              }\n\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n              .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(4) {\n                z-index: 4 !important;\n                background-color: #F5F5F7 !important;\n              }\n\n              @media (max-width: 991.98px) {\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n                .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(1),\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n                .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(2),\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n                .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(3),\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n                .reservation-pinned-table .rdt_TableRow .rdt_TableCell:nth-child(4) {\n                  position: static !important;\n                  left: auto !important;\n                  z-index: auto !important;\n                  box-shadow: none !important;\n                }\n\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n                .reservation-pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(4) {\n                  background-color: #F5F5F7 !important;\n                }\n              }\n            "
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: waitDeliveryOnly ? "" : "reservation-pinned-table",
                                        children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                            item: filteredItems,
                                            columns: columns,
                                            isSelectRows: false,
                                            currentPage: pageId,
                                            currentPageSize: pageSize,
                                            onChangePage: handleChangePage,
                                            onChangePageSize: handleChangeRowsPerPage,
                                            totalPage: totalPage,
                                            totalAmount: totalAmount,
                                            sortModel: sortModel,
                                            handleSort: handleSort,
                                            loading: loading
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: "none"
                },
                children: /*#__PURE__*/ _jsx(PagePrint, {
                    ref: componentRef,
                    dataFrom: reservationData,
                    dataItem: dataItem,
                    typeDocPrint: 1,
                    docType: printDocType
                })
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: createReservationShow,
                onHide: handleCloseCreateReservation,
                centered: true,
                backdrop: creatingReservation ? "static" : true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: !creatingReservation,
                        className: "modal-header-danger",
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: "สร้างใบจอง"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        children: [
                                            "ร้านค้า ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Select, _object_spread({
                                        placeholder: "เลือกร้านค้า",
                                        options: createShopOptions,
                                        value: createShopOptions.find(function(option) {
                                            return Number(option.value) === Number(createShopId);
                                        }) || null,
                                        onChange: function(option) {
                                            setCreateShopId((option === null || option === void 0 ? void 0 : option.value) || "");
                                            setCreateBranchId("");
                                        },
                                        isLoading: getReservationCreateShopReducer.isFetching,
                                        isDisabled: creatingReservation,
                                        isClearable: true
                                    }, selectMenuPortalProps))
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Form.Group, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        children: [
                                            "สาขา ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-danger",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Select, _object_spread({
                                        placeholder: createShopId ? "เลือกสาขา" : "กรุณาเลือกร้านค้าก่อน",
                                        options: createBranchOptions,
                                        value: createBranchOptions.find(function(option) {
                                            return Number(option.value) === Number(createBranchId);
                                        }) || null,
                                        onChange: function(option) {
                                            return setCreateBranchId((option === null || option === void 0 ? void 0 : option.value) || "");
                                        },
                                        isLoading: getReservationCreateShopReducer.isFetching,
                                        isDisabled: !createShopId || creatingReservation,
                                        isClearable: true
                                    }, selectMenuPortalProps))
                                ]
                            }),
                            userRoleId === 3 && createShopOptions.length === 0 ? /*#__PURE__*/ _jsx(Alert, {
                                severity: "warning",
                                className: "mt-3",
                                children: "ไม่พบสาขาร้านค้าที่คุณเป็นผู้ดูแล"
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Footer, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                variant: "secondary",
                                onClick: handleCloseCreateReservation,
                                disabled: creatingReservation,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-3",
                                onClick: handleCreateReservation,
                                disabled: !createShopId || !createBranchId || creatingReservation,
                                children: creatingReservation ? "กำลังสร้าง..." : "สร้างใบจอง"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ChangeStatusContactModal, {
                show: chgStSalesShow,
                onHide: handleChgSalesClose,
                reportId: reportId,
                statusId: statusId,
                setStatusId: setStatusId,
                setReData: setReData,
                reserveCode: reserveCode,
                reserveResetNote: reserveResetNote,
                branchCreditStatus: reserveBranchCreditStatus,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                successDirection: reservationListDirection
            }),
            /*#__PURE__*/ _jsx(ChangeStatusListModal, {
                show: chgStListShow,
                onHide: handleChgListClose,
                reportId: reportListId,
                statusId: stListId,
                setStatusId: setStListId,
                statusSale: statusSale,
                setReData: setReData,
                reserveCode: reserveCodeList,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                successDirection: reservationListDirection,
                deliveryProblemOptions: deliveryProblemOptions,
                reservationManagementOnly: reservationManagementOnly
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: shopNameModal.show,
                onHide: function() {
                    return setShopNameModal({
                        show: false,
                        text: ""
                    });
                },
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: "ชื่อร้าน"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Body, {
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                wordBreak: "break-word"
                            },
                            children: safeText(shopNameModal.text)
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Footer, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "secondary",
                            onClick: function() {
                                return setShopNameModal({
                                    show: false,
                                    text: ""
                                });
                            },
                            children: "ปิด"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: cancelNoteModal.show,
                onHide: function() {
                    return setCancelNoteModal({
                        show: false,
                        text: ""
                    });
                },
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        className: "modal-header-danger",
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: "หมายเหตุการยกเลิก"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Body, {
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                whiteSpace: "pre-wrap"
                            },
                            children: cancelNoteModal.text
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Footer, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "outline-secondary",
                            onClick: function() {
                                return setCancelNoteModal({
                                    show: false,
                                    text: ""
                                });
                            },
                            children: "ปิด"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: deliveryProblemModal.show,
                onHide: function() {
                    return setDeliveryProblemModal({
                        show: false,
                        problem: "",
                        note: ""
                    });
                },
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        className: "modal-header-danger",
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            children: "ปัญหาการส่งสินค้า"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fw-semibold mb-1",
                                        children: "ปัญหาในการส่งสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        children: deliveryProblemModal.problem || "-"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fw-semibold mb-1",
                                        children: "หมายเหตุ"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word"
                                        },
                                        children: deliveryProblemModal.note || "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Modal.Footer, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "secondary",
                            onClick: function() {
                                return setDeliveryProblemModal({
                                    show: false,
                                    problem: "",
                                    note: ""
                                });
                            },
                            children: "ปิด"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            }),
            /*#__PURE__*/ _jsx(Snackbar, {
                open: copyTrackingNotice.open,
                autoHideDuration: 2500,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                onClose: function(_, reason) {
                    if (reason === "clickaway") return;
                    setCopyTrackingNotice(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            open: false
                        });
                    });
                },
                children: /*#__PURE__*/ _jsx(Alert, {
                    severity: copyTrackingNotice.severity,
                    variant: "filled",
                    onClose: function() {
                        return setCopyTrackingNotice(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: false
                            });
                        });
                    },
                    sx: {
                        width: "100%"
                    },
                    children: copyTrackingNotice.message
                })
            })
        ]
    });
}
export function ReportReservationWaitDelivery() {
    return /*#__PURE__*/ _jsx(ReportReservation, {
        waitDeliveryOnly: true
    });
}
export function ReservationManagement() {
    return /*#__PURE__*/ _jsx(ReportReservation, {
        reservationManagementOnly: true
    });
}
function StatusContactSale(_param) {
    var reportId = _param.reportId, statusId = _param.statusId, props = _object_without_properties(_param, [
        "reportId",
        "statusId"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var statusName = props.statusName && props.statusName.trim() !== "" ? props.statusName.trim() : "ไม่ระบุ";
    var reserveCode = props.reserveCode && props.reserveCode.trim() !== "" ? props.reserveCode.trim() : "";
    var isCancelled = parseInt(statusId, 10) === 3;
    var isReadOnly = Boolean(props.readOnly);
    var handleClick = function() {
        var itemId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, statusId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (isCancelled || isReadOnly) return;
        if (itemId && itemId > 0) {
            props.setReportId(itemId);
            props.setStatusId(statusId);
            props.handleOpen();
            props.setReserveCode(reserveCode);
            props.setReserveResetNote(props.resetNote || "");
            props.setReserveBranchCreditStatus(Number(props.branchCreditStatus || 1));
        }
    };
    return /*#__PURE__*/ _jsx(Row, {
        children: /*#__PURE__*/ _jsx(Col, {
            xs: 12,
            children: /*#__PURE__*/ _jsx(ButtonMui, {
                variant: "contained",
                endIcon: !isReadOnly ? /*#__PURE__*/ _jsx(ArrowDropDownIcon, {}) : undefined,
                className: "px-2 py-1 text-center",
                onClick: function() {
                    return handleClick(reportId, statusId);
                },
                disabled: isCancelled || isReadOnly,
                style: {
                    color: statusId && statusId === 4 ? "#6f42c1" : statusId && statusId === 3 ? "rgba(211, 47, 47, 1)" : statusId && statusId === 2 ? "rgba(255, 255, 255, 1)" : statusId && statusId === 1 ? "rgba(253, 180, 40, 1)" : "rgba(116, 116, 116, 1)",
                    backgroundColor: statusId && statusId === 4 ? "#e2d9f3" : statusId && statusId === 3 ? "rgba(253, 237, 237, 1)" : statusId && statusId === 2 ? "rgba(16, 176, 42, 1)" : statusId && statusId === 1 ? "rgba(255, 246, 229, 1)" : "rgba(244, 244, 244, 1)",
                    borderRadius: "20px",
                    width: "130px",
                    cursor: isCancelled || isReadOnly ? "default" : "pointer"
                },
                children: statusName
            })
        })
    });
}
function ChangeStatusContactModal(_param) {
    var reportId = _param.reportId, statusId = _param.statusId, props = _object_without_properties(_param, [
        "reportId",
        "statusId"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), resetNote = _useState1[0], setResetNote = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), cancelNote = _useState2[0], setCancelNote = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), selectedStatusId = _useState3[0], setSelectedStatusId = _useState3[1];
    var _useState4 = _sliced_to_array(useState(optionsStatusContact), 2), optStContact = _useState4[0], setOptStContact = _useState4[1];
    var reserveCode = props.reserveCode && props.reserveCode.trim() !== "" ? props.reserveCode.trim() : "";
    var updateStatusSalesReducer = useAppSelector(function(state) {
        return state.updateStatusSalesReducer;
    });
    var handleClick = function(val) {
        var normalizedResetNote = resetNote.trim();
        var normalizedCancelNote = cancelNote.trim();
        var selectedSaleStatus = parseInt(selectedStatusId, 10);
        if (selectedSaleStatus === 2 && Number(props.branchCreditStatus || 1) === 2) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "สาขานี้ได้ระงับวงเงินเครดิต"
            }));
            return;
        }
        if (selectedSaleStatus === 4 && !normalizedResetNote) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกหมายเหตุการรีเซ็ตสถานะเซลล์ติดต่อลูกค้า"
            }));
            return;
        }
        if (selectedSaleStatus === 3 && !normalizedCancelNote) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกหมายเหตุการยกเลิก"
            }));
            return;
        }
        if (reportId && reportId != "" && reportId > 0) {
            setIsLoading(true);
            var payload = _object_spread({
                reserveid: parseInt(reportId, 10),
                reservesalestatus: selectedSaleStatus
            }, selectedSaleStatus === 4 && {
                rs_reserve_resetnote: normalizedResetNote
            }, selectedSaleStatus === 3 && {
                rs_reserve_cancelnote: normalizedCancelNote
            });
            dispatch(updateStatusSales(payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาเลือกรายการที่ต้องการจะเปลี่ยนสถานะเซลล์ติดต่ออีกครั้ง"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusSalesReducer.isFetching);
        if (reportId && reportId != "" && reportId != null) {
            if (updateStatusSalesReducer.data && !updateStatusSalesReducer.isError) {
                var updatedData = updateStatusSalesReducer.data.data;
                dispatch(clearUpdateStatusSales());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "เปลี่ยนสถานะเซลล์ติดต่อ เลขที่ใบจอง " + reserveCode + " เรียบร้อย",
                            direction: props.successDirection
                        });
                    });
                    setIsBoxAlert(false);
                    props.setReData(true);
                }
            }
        }
    }, [
        updateStatusSalesReducer
    ]);
    useEffect(function() {
        if (props.show) {
            setResetNote(props.reserveResetNote || "");
            setCancelNote("");
            setSelectedStatusId(statusId || 0);
        }
    }, [
        props.show,
        props.reserveResetNote,
        statusId
    ]);
    useEffect(function() {
        if (statusId && statusId > 0) {
            if (statusId == 2) {
                setOptStContact(optionsStatusContact.filter(function(item) {
                    return item.value == 2 || item.value == 4;
                }));
            } else if (statusId == 3) {
                setOptStContact(optionsStatusContact.filter(function(item) {
                    return item.value == 3;
                }));
            } else {
                setOptStContact(optionsStatusContact.filter(function(item) {
                    return item.value != 4;
                }));
            }
        }
    }, [
        statusId
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "แก้ไขสถานะเซลล์ติดต่อ"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx(Row, {
                        className: "align-items-center mt-3",
                        children: /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        className: "mb-1",
                                        children: [
                                            "สถานะเซลล์ติดต่อ ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "span-red-gb",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "statusContact",
                                        onChange: function(e) {
                                            setSelectedStatusId(e.value);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optStContact,
                                        placeholder: "เลือกสถานะเซลล์ติดต่อ",
                                        value: optStContact.filter(function(item2) {
                                            return item2.value === selectedStatusId;
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    parseInt(selectedStatusId, 10) === 4 && /*#__PURE__*/ _jsx(Row, {
                        className: "align-items-center mt-3",
                        children: /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        className: "mb-1",
                                        children: [
                                            "หมายเหตุการรีเซ็ต ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "span-red-gb",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        as: "textarea",
                                        rows: 3,
                                        name: "rs_reserve_resetnote",
                                        placeholder: "กรอกหมายเหตุการรีเซ็ต",
                                        style: {
                                            resize: "none"
                                        },
                                        value: resetNote,
                                        onChange: function(e) {
                                            return setResetNote(e.target.value);
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    parseInt(selectedStatusId, 10) === 3 && /*#__PURE__*/ _jsx(Row, {
                        className: "align-items-center mt-3",
                        children: /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        className: "mb-1",
                                        children: [
                                            "หมายเหตุการยกเลิก ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "span-red-gb",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        as: "textarea",
                                        rows: 3,
                                        name: "rs_reserve_cancelnote",
                                        placeholder: "กรอกหมายเหตุการยกเลิก",
                                        style: {
                                            resize: "none"
                                        },
                                        value: cancelNote,
                                        onChange: function(e) {
                                            return setCancelNote(e.target.value);
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    }));
}
function StatusReservation(_param) {
    var reportId = _param.reportId, statusId = _param.statusId, props = _object_without_properties(_param, [
        "reportId",
        "statusId"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var currentStatusId = statusId && statusId > 0 ? parseInt(statusId, 10) : 0;
    var statusName = props.statusName && props.statusName.trim() !== "" ? props.statusName.trim() : "ไม่ระบุ";
    var statusSale = props.statusSale && props.statusSale > 0 ? parseInt(props.statusSale, 10) : 0;
    var reserveCode = props.reserveCode && props.reserveCode.trim() !== "" ? props.reserveCode.trim() : "";
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var userRoleId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) || 0);
    var hasStatusAction = getReserveStatusOptions(currentStatusId, userRoleId, props.reservationManagementOnly).length > 0;
    var canManageReserveStatus = Number(adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) > 0;
    var handleClick = function() {
        var itemId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, statusId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, statusSale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        if (itemId && itemId > 0 && statusSale === 2) {
            props.setReportListId(itemId);
            props.setStListId(statusId);
            props.setStatusSale(statusSale);
            props.setReserveCodeList(reserveCode);
            props.handleOpen();
        } else {
            if (statusSale !== 2) {
                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                    visible: true,
                    subTitle: "รหัส 201",
                    navigateDirection: undefined,
                    title: "กรุณายืนยันสถานะเซลล์ติดต่อก่อนที่จะเปลี่ยนสถานะรายการ"
                }));
            }
        }
    };
    return /*#__PURE__*/ _jsx(Row, {
        children: /*#__PURE__*/ _jsx(Col, {
            xs: 12,
            children: /*#__PURE__*/ _jsx(ButtonMui, {
                variant: "contained",
                endIcon: /*#__PURE__*/ _jsx(ArrowDropDownIcon, {}),
                className: "px-2 py-1 text-center",
                onClick: function() {
                    if (hasStatusAction && canManageReserveStatus) {
                        handleClick(reportId, currentStatusId, statusSale);
                    }
                },
                style: _object_spread_props(_object_spread({}, getReserveStatusStyle(currentStatusId)), {
                    borderRadius: "20px",
                    width: "135px"
                }),
                disabled: !(canManageReserveStatus && hasStatusAction),
                children: statusName
            })
        })
    });
}
function ChangeStatusListModal(_param) {
    var reportId = _param.reportId, statusId = _param.statusId, props = _object_without_properties(_param, [
        "reportId",
        "statusId"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var reserveCode = props.reserveCode && props.reserveCode.trim() !== "" ? props.reserveCode.trim() : "";
    var statusSale = props.statusSale && props.statusSale > 0 ? parseInt(props.statusSale, 10) : 0;
    var currentStatusId = statusId && statusId > 0 ? parseInt(statusId, 10) : 0;
    var adminInfo = getInfoAdminSystem(localStorage.getItem("accessToken"));
    var userRoleId = Number((adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userRoleId) || 0);
    var _useState1 = _sliced_to_array(useState([]), 2), optStList = _useState1[0], setOptStList = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), selectedStatusId = _useState2[0], setSelectedStatusId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), datePass = _useState3[0], setDatePass = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), deliveryProblemId = _useState4[0], setDeliveryProblemId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), deliveryProblemNote = _useState5[0], setDeliveryProblemNote = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), reservePayDate = _useState6[0], setReservePayDate = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), reserveInvoiceCode = _useState7[0], setReserveInvoiceCode = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), paymentFiles = _useState8[0], setPaymentFiles = _useState8[1];
    var paymentFilePreviews = useMemo(function() {
        return paymentFiles.map(function(file, index) {
            var _file_type;
            return {
                index: index,
                file: file,
                previewUrl: (file === null || file === void 0 ? void 0 : (_file_type = file.type) === null || _file_type === void 0 ? void 0 : _file_type.startsWith("image/")) ? URL.createObjectURL(file) : ""
            };
        });
    }, [
        paymentFiles
    ]);
    var updateStatusReserveReducer = useAppSelector(function(state) {
        return state.updateStatusReserveReducer;
    });
    var handleClick = function() {
        if (!(reportId && reportId !== "" && reportId > 0 && statusSale === 2)) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณายืนยันสถานะเซลล์ติดต่อก่อนที่จะเปลี่ยนสถานะรายการ"
            }));
            props.onHide();
            return;
        }
        if (props.reservationManagementOnly && !(currentStatusId === WAIT_DELIVERY_STATUS && selectedStatusId === 2 || currentStatusId === 2 && selectedStatusId === 6 || currentStatusId === 6 && selectedStatusId === 2)) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 403",
                navigateDirection: undefined,
                title: "หน้านี้เปลี่ยนสถานะได้เฉพาะ รอส่งสินค้า เป็น ส่งสินค้าแล้ว, ส่งสินค้าแล้ว เป็น ชำระเงินแล้ว หรือรีเซ็ต ชำระเงินแล้ว กลับเป็น ส่งสินค้าแล้ว"
            }));
            return;
        }
        if (currentStatusId === 4 && selectedStatusId === 7 && userRoleId !== 9) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 403",
                navigateDirection: undefined,
                title: "เฉพาะผู้ใช้งาน หัวหน้าคลัง เท่านั้นที่สามารถเปลี่ยนสถานะเป็นตรวจสอบสินค้าได้"
            }));
            return;
        }
        if (!(selectedStatusId && selectedStatusId > 0)) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาเลือกสถานะรายการ"
            }));
            return;
        }
        if (currentStatusId === 7 && selectedStatusId === 7) {
            props.onHide();
            navigate("/report/reservation/product-check/".concat(reportId));
            return;
        }
        if (selectedStatusId === 2 && currentStatusId !== 6 && !datePass) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาเลือกวันที่ส่งสินค้า"
            }));
            return;
        }
        if (currentStatusId === 5 && selectedStatusId === 2 && Number(deliveryProblemId) === 99 && deliveryProblemNote.trim() === "") {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกหมายเหตุ เมื่อเลือกปัญหาการส่งสินค้าเป็น อื่นๆ"
            }));
            return;
        }
        if (selectedStatusId === 6 && !reservePayDate) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาเลือกวันที่ชำระเงิน"
            }));
            return;
        }
        if (selectedStatusId === 6 && reserveInvoiceCode.trim() === "") {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกรหัสใบแจ้งหนี้"
            }));
            return;
        }
        if (selectedStatusId === 6 && paymentFiles.length === 0) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาแนบรูปหลักฐานชำระเงินอย่างน้อย 1 ไฟล์"
            }));
            return;
        }
        setIsLoading(true);
        var payload = _object_spread({
            reserveid: parseInt(reportId, 10),
            reserveadminstatus: parseInt(selectedStatusId, 10)
        }, selectedStatusId === 2 && datePass && {
            reservedatepass: moment(datePass).format("YYYY-MM-DD")
        }, currentStatusId === 5 && selectedStatusId === 2 && {
            reservedeliveryproblemid: deliveryProblemId || null,
            reservedeliveryproblemnote: deliveryProblemNote.trim() || null
        });
        if (selectedStatusId === 6) {
            var formData = new FormData();
            formData.append("reserveid", String(parseInt(reportId, 10)));
            formData.append("reserveadminstatus", String(parseInt(selectedStatusId, 10)));
            formData.append("reservepaydate", moment(reservePayDate).format("YYYY-MM-DD"));
            formData.append("reserveinvoicecode", reserveInvoiceCode.trim());
            paymentFiles.forEach(function(file) {
                formData.append("reserve_payment_files", file);
            });
            payload = formData;
        }
        dispatch(updateStatusReserve(payload, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        setIsBoxAlert(true);
        props.onHide();
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusReserveReducer.isFetching);
        if (reportId && reportId != "" && reportId != null) {
            if (updateStatusReserveReducer.data && !updateStatusReserveReducer.isError) {
                var updatedData = updateStatusReserveReducer.data.data;
                dispatch(clearUpdateStatusReserve());
                if (isBoxAlert) {
                    props.setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: true,
                            textsuccess: "เปลี่ยนสถานะ เลขที่ใบจอง " + reserveCode + " เรียบร้อย",
                            direction: props.successDirection
                        });
                    });
                    setIsBoxAlert(false);
                    props.setReData(true);
                }
            }
        }
    }, [
        updateStatusReserveReducer
    ]);
    useEffect(function() {
        setOptStList(getReserveStatusOptions(currentStatusId, userRoleId, props.reservationManagementOnly));
        setSelectedStatusId(0);
        setDatePass(null);
        setDeliveryProblemId("");
        setDeliveryProblemNote("");
        setReservePayDate(null);
        setReserveInvoiceCode("");
        setPaymentFiles([]);
    }, [
        currentStatusId,
        props.show,
        props.reservationManagementOnly,
        userRoleId
    ]);
    useEffect(function() {
        if (selectedStatusId !== 2) {
            setDatePass(null);
            setDeliveryProblemId("");
            setDeliveryProblemNote("");
        }
        if (selectedStatusId !== 6) {
            setReservePayDate(null);
            setReserveInvoiceCode("");
            setPaymentFiles([]);
        }
    }, [
        selectedStatusId
    ]);
    useEffect(function() {
        return function() {
            paymentFilePreviews.forEach(function(item) {
                if (item.previewUrl) {
                    URL.revokeObjectURL(item.previewUrl);
                }
            });
        };
    }, [
        paymentFilePreviews
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "แก้ไขสถานะรายการ"
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx(Row, {
                        className: "align-items-center mt-3",
                        children: /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        className: "mb-1",
                                        children: [
                                            "สถานะรายการ ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "span-red-gb",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "statusList",
                                        onChange: function(e) {
                                            var _e_value;
                                            setSelectedStatusId((_e_value = e === null || e === void 0 ? void 0 : e.value) !== null && _e_value !== void 0 ? _e_value : 0);
                                        },
                                        className: "w-100 select-st-1",
                                        options: optStList,
                                        placeholder: "เลือกสถานะรายการ",
                                        value: optStList.find(function(item2) {
                                            return item2.value === selectedStatusId;
                                        }) || null
                                    })
                                ]
                            })
                        })
                    }),
                    currentStatusId === 6 && selectedStatusId === 2 ? /*#__PURE__*/ _jsx("div", {
                        className: "alert alert-warning mt-2",
                        role: "alert",
                        children: "เมื่อกดยืนยัน ระบบจะล้างผู้บันทึกชำระ วันที่ชำระ เลขใบแจ้งหนี้ และหลักฐานชำระเงินออกจากใบจอง โดยเก็บประวัติเดิมไว้ตรวจสอบย้อนหลัง และคงข้อมูลส่งสินค้าเดิมไว้"
                    }) : null,
                    selectedStatusId === 2 && currentStatusId !== 6 ? /*#__PURE__*/ _jsx(Row, {
                        className: "align-items-center mt-2",
                        children: /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                        className: "mb-1",
                                        children: [
                                            "วันที่ส่งสินค้า ",
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "span-red-gb",
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(DatePicker, {
                                        selected: datePass,
                                        onChange: function(date) {
                                            return setDatePass(date);
                                        },
                                        dateFormat: "dd-MM-yyyy",
                                        className: "form-control px-2",
                                        placeholderText: "เลือกวันที่ส่งสินค้า"
                                    })
                                ]
                            })
                        })
                    }) : null,
                    currentStatusId === 5 && selectedStatusId === 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Row, {
                                className: "align-items-center mt-2",
                                children: /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ปัญหาในการส่งสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                name: "deliveryProblem",
                                                className: "w-100 select-st-1",
                                                options: props.deliveryProblemOptions || [],
                                                placeholder: "เลือกปัญหาในการส่งสินค้า",
                                                isClearable: true,
                                                value: (props.deliveryProblemOptions || []).find(function(item) {
                                                    return Number(item.value) === Number(deliveryProblemId);
                                                }) || null,
                                                onChange: function(option) {
                                                    var nextProblemId = (option === null || option === void 0 ? void 0 : option.value) || "";
                                                    setDeliveryProblemId(nextProblemId);
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Row, {
                                className: "align-items-center mt-2",
                                children: /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "หมายเหตุ",
                                                    Number(deliveryProblemId) === 99 ? /*#__PURE__*/ _jsx("span", {
                                                        className: "span-red-gb",
                                                        children: " *"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                as: "textarea",
                                                rows: 3,
                                                value: deliveryProblemNote,
                                                onChange: function(event) {
                                                    return setDeliveryProblemNote(event.target.value);
                                                },
                                                placeholder: "กรอกข้อมูลเพิ่มเติม",
                                                maxLength: 2000
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }) : null,
                    selectedStatusId === 6 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "align-items-center mt-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-1",
                                                    children: [
                                                        "วันที่ชำระเงิน ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "span-red-gb",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: reservePayDate,
                                                    onChange: function(date) {
                                                        return setReservePayDate(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2",
                                                    placeholderText: "เลือกวันที่ชำระเงิน"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-1",
                                                    children: [
                                                        "รหัสใบแจ้งหนี้ ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "span-red-gb",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    value: reserveInvoiceCode,
                                                    onChange: function(e) {
                                                        return setReserveInvoiceCode(e.target.value);
                                                    },
                                                    placeholder: "กรอกรหัสใบแจ้งหนี้",
                                                    maxLength: 255
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Row, {
                                className: "align-items-center mt-2",
                                children: /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "แนบรูปหลักฐานชำระเงิน ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "span-red-gb",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "file",
                                                accept: "image/*",
                                                multiple: true,
                                                onChange: function(e) {
                                                    var nextFiles = Array.from(e.target.files || []);
                                                    if (nextFiles.length > 0) {
                                                        setPaymentFiles(function(prev) {
                                                            return _to_consumable_array(prev).concat(_to_consumable_array(nextFiles));
                                                        });
                                                    }
                                                    e.target.value = "";
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Text, {
                                                className: "text-muted",
                                                children: "รองรับหลายรูป และจะอัปโหลดพร้อมการเปลี่ยนสถานะ"
                                            })
                                        ]
                                    })
                                })
                            }),
                            paymentFiles.length > 0 ? /*#__PURE__*/ _jsx(Row, {
                                className: "mt-2 g-2",
                                children: paymentFilePreviews.map(function(param) {
                                    var file = param.file, index = param.index, previewUrl = param.previewUrl;
                                    return /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "border rounded-3 px-3 py-2 h-100",
                                            style: {
                                                backgroundColor: "#f8fbff"
                                            },
                                            children: [
                                                previewUrl ? /*#__PURE__*/ _jsx(ImageBst, {
                                                    src: previewUrl,
                                                    alt: file.name,
                                                    fluid: true,
                                                    className: "rounded mb-2",
                                                    style: {
                                                        width: "100%",
                                                        height: "160px",
                                                        objectFit: "cover"
                                                    }
                                                }) : null,
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "d-flex align-items-start justify-content-between gap-2",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fw-semibold text-truncate",
                                                            children: file.name
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            variant: "outline-danger",
                                                            size: "sm",
                                                            onClick: function() {
                                                                return setPaymentFiles(function(prev) {
                                                                    return prev.filter(function(_, fileIndex) {
                                                                        return fileIndex !== index;
                                                                    });
                                                                });
                                                            },
                                                            children: "ลบ"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "small text-muted",
                                                    children: formatFileSize(file.size)
                                                })
                                            ]
                                        })
                                    }, "".concat(file.name, "-").concat(index));
                                })
                            }) : null
                        ]
                    }) : null,
                    optStList.length === 0 ? /*#__PURE__*/ _jsx("div", {
                        className: "text-secondary fs-14 mt-2",
                        children: "สถานะปัจจุบันไม่มีรายการให้เปลี่ยนต่อ"
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ตกลง"
                    })
                ]
            })
        ]
    }));
}
var PagePrint = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var dataFrom = _param.dataFrom, dataItem = _param.dataItem, props = _object_without_properties(_param, [
        "dataFrom",
        "dataItem"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var typeDocPrint = props.typeDocPrint ? props.typeDocPrint : 1;
    var sortedDataItems = sortReservationCatalogItems(dataItem);
    var _useState = _sliced_to_array(useState(""), 2), companyName = _useState[0], setCompanyName = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), companyBranch = _useState1[0], setCompanyBranch = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), rsReserveCode = _useState2[0], setRsReserveCode = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), rsIssueDate = _useState3[0], setRsIssueDate = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), rsStatus = _useState4[0], setRsStatus = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), rsSaleName = _useState5[0], setRsSaleName = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), contactName = _useState6[0], setContactName = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), contactPhone = _useState7[0], setContactPhone = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), subContactName = _useState8[0], setSubContactName = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), subContactPhone = _useState9[0], setSubContactPhone = _useState9[1];
    useEffect(function() {
        if (dataFrom) {
            if (dataFrom.rs_reserve_shopname && dataFrom.rs_reserve_shopname != "" && dataFrom.rs_reserve_shopname != null) {
                setCompanyName(dataFrom.rs_reserve_shopname.trim());
            }
            if (dataFrom.rs_reserve_branchname && dataFrom.rs_reserve_branchname != "" && dataFrom.rs_reserve_branchname != null && dataFrom.rs_reserve_branchname != "สำนักงานใหญ่") {
                var _dataFrom_shBranch;
                setCompanyBranch("สาขา " + formatPdfBranchName(dataFrom.rs_reserve_branchname, (_dataFrom_shBranch = dataFrom.shBranch) === null || _dataFrom_shBranch === void 0 ? void 0 : _dataFrom_shBranch.sh_branch_code));
            } else {
                var _dataFrom_shBranch1;
                setCompanyBranch(formatPdfBranchName("สำนักงานใหญ่", (_dataFrom_shBranch1 = dataFrom.shBranch) === null || _dataFrom_shBranch1 === void 0 ? void 0 : _dataFrom_shBranch1.sh_branch_code));
            }
            if (dataFrom.rs_reserve_code && dataFrom.rs_reserve_code != "" && dataFrom.rs_reserve_code != null) {
                setRsReserveCode(dataFrom.rs_reserve_code.trim());
            }
            if (dataFrom.rs_reserve_credate && dataFrom.rs_reserve_credate != "" && dataFrom.rs_reserve_credate != null) {
                setRsIssueDate(formatDbDate(dataFrom.rs_reserve_credate));
            }
            if (dataFrom.rs_reserve_status_text && dataFrom.rs_reserve_status_text != "" && dataFrom.rs_reserve_status_text != null) {
                setRsStatus(dataFrom.rs_reserve_status_text.trim());
            }
            if (dataFrom.reserve_salename && dataFrom.reserve_salename != "" && dataFrom.reserve_salename != null) {
                setRsSaleName(dataFrom.reserve_salename.trim());
            }
            if (dataFrom.rs_reserve_contactname && dataFrom.rs_reserve_contactname != "" && dataFrom.rs_reserve_contactname != null) {
                setContactName(dataFrom.rs_reserve_contactname.trim());
            }
            if (dataFrom.rs_reserve_contactphone && dataFrom.rs_reserve_contactphone != "" && dataFrom.rs_reserve_contactphone != null) {
                setContactPhone(dataFrom.rs_reserve_contactphone.trim());
            }
            if (dataFrom.rs_reserve_suptactname && dataFrom.rs_reserve_suptactname != "" && dataFrom.rs_reserve_suptactname != null) {
                setSubContactName(dataFrom.rs_reserve_suptactname.trim());
            }
            if (dataFrom.rs_reserve_suptactphone && dataFrom.rs_reserve_suptactphone != "" && dataFrom.rs_reserve_suptactphone != null) {
                setSubContactPhone(dataFrom.rs_reserve_suptactphone.trim());
            }
        }
    }, [
        dataFrom
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "text-[12.5px] text-[#2C2C2C] mb-1",
            style: {
                width: "210mm",
                height: "297mm",
                padding: "5px 30px",
                margin: "0",
                background: "white",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/images/pardesco-logo-new-black-200.png",
                                    className: "w-[100px]"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6 text-end",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "mt-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "ml-5",
                                        children: [
                                            "(",
                                            typeDocPrint && typeDocPrint == 1 ? "ต้นฉบับ" : "สำเนา",
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-18 text-danger fw-bold",
                                        children: "ใบจองสินค้า"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-end mt-2",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px]",
                            style: {
                                borderBottom: "1px solid #909090"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[40px]",
                                            children: "ลูกค้า :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[195px]",
                                            children: companyName && companyName != "" ? companyName + " (" + companyBranch + ")" : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[60px]",
                                            children: "ผู้ติดต่อ 1 :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[175px]",
                                            children: contactName !== null && contactName !== void 0 ? contactName : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex-none w-[30px]",
                                            children: [
                                                /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                }),
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "ml-1",
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[205px]",
                                            children: contactPhone !== null && contactPhone !== void 0 ? contactPhone : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px]",
                            style: {
                                borderBottom: "1px solid #909090"
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[70px]",
                                            children: "เซลล์ที่ดูแล :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[165px]",
                                            children: rsSaleName !== null && rsSaleName !== void 0 ? rsSaleName : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[60px]",
                                            children: "ผู้ติดต่อ 2 :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[175px]",
                                            children: subContactName !== null && subContactName !== void 0 ? subContactName : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex-none w-[30px]",
                                            children: [
                                                /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                }),
                                                " ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "ml-1",
                                                    children: ":"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[205px]",
                                            children: subContactPhone !== null && subContactPhone !== void 0 ? subContactPhone : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grow pr-[20px] px-2 pt-2",
                            style: {
                                background: "#F6E1E3",
                                borderRadius: 5
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "เลขที่เอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: rsReserveCode !== null && rsReserveCode !== void 0 ? rsReserveCode : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "วันที่ออกเอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: rsIssueDate !== null && rsIssueDate !== void 0 ? rsIssueDate : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]",
                                            children: "สถานะ :"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000] w-[80px]",
                                            children: rsStatus !== null && rsStatus !== void 0 ? rsStatus : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "py-2",
                    children: /*#__PURE__*/ _jsxs("table", {
                        className: "w-full table-print",
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 2,
                                    borderColor: "#F6E1E3"
                                },
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y text-center font-normal",
                                            children: [
                                                "ลำดับ",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y text-center font-normal",
                                            children: "รูปสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "ชื่อสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "บาร์โค้ด"
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "ขนาดบรรจุ"
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: [
                                                "จำนวนสินค้า",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            valign: "middle",
                                            width: "10%",
                                            style: {
                                                width: "10%"
                                            },
                                            className: "border-x border-y  text-center font-normal",
                                            children: "หน่วย"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("tbody", {
                                children: sortedDataItems && sortedDataItems.length > 0 ? sortedDataItems.map(function(item, index) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            height: "30px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: /*#__PURE__*/ _jsx("p", {
                                                    className: "py-[10px] w-[30px]",
                                                    children: "".concat(index + 1)
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: item.rs_catalog_image && item.rs_catalog_image != "" && item.rs_catalog_image != null ? /*#__PURE__*/ _jsx(ImageBst, {
                                                    src: item.rs_catalog_image,
                                                    alt: item.rs_catalog_name,
                                                    style: {
                                                        maxWidth: 90,
                                                        maxHeight: 90
                                                    }
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                className: "border-x ellipsis br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "py-[10px] w-[170px]",
                                                        style: {
                                                            textWrap: "balance"
                                                        },
                                                        children: "".concat(item.rs_catalog_name)
                                                    }),
                                                    Number(item.rs_catalog_free) === 2 ? /*#__PURE__*/ _jsx("p", {
                                                        className: "w-[170px] text-[#B00412]",
                                                        children: "ของแถม"
                                                    }) : null,
                                                    Number(item.rs_catalog_tester) === 2 ? /*#__PURE__*/ _jsx("p", {
                                                        className: "w-[170px] text-[#B00412]",
                                                        children: "สินค้าทดลอง"
                                                    }) : null,
                                                    item.rs_catalog_remark ? /*#__PURE__*/ _jsxs("p", {
                                                        className: "w-[170px]",
                                                        style: {
                                                            textWrap: "balance"
                                                        },
                                                        children: [
                                                            "หมายเหตุ: ",
                                                            item.rs_catalog_remark
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: item.rsDetail.map(function(b, i) {
                                                    return b.rs_detail_amount && b.rs_detail_amount > 0 ? /*#__PURE__*/ _jsx("p", {
                                                        className: "py-[10px]",
                                                        children: "".concat(b.rs_detail_barcode)
                                                    }, i) : /*#__PURE__*/ _jsx(_Fragment, {});
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-left br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: item.rsDetail.map(function(b, i) {
                                                    var _b_set_unit_name;
                                                    return b.rs_detail_amount && b.rs_detail_amount > 0 ? /*#__PURE__*/ _jsxs("p", {
                                                        className: "py-[10px] w-[120px]",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                style: {
                                                                    float: "left",
                                                                    width: "30px"
                                                                },
                                                                children: " ".concat((_b_set_unit_name = b.set_unit_name) !== null && _b_set_unit_name !== void 0 ? _b_set_unit_name : "หน่วย")
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "="
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "ml-1",
                                                                children: b.rs_detail_ratio && b.rs_detail_ratio > 0 ? " ".concat(b.rs_detail_ratio) : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "ml-1",
                                                                children: b.rs_detail_ratio && b.rs_detail_ratio > 0 ? "ชิ้น" : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "ml-1",
                                                                children: b.rs_detail_ratiooption && b.rs_detail_ratiooption > 0 ? "/ ".concat(b.rs_detail_ratiooption, " แพ็ค") : ""
                                                            })
                                                        ]
                                                    }, i) : /*#__PURE__*/ _jsx(_Fragment, {});
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: item.rsDetail.map(function(b, i) {
                                                    return b.rs_detail_amount && b.rs_detail_amount > 0 ? /*#__PURE__*/ _jsx("p", {
                                                        className: "py-[10px] w-[90px]",
                                                        children: "".concat(NumberFormat(b.rs_detail_amount, 0))
                                                    }, i) : /*#__PURE__*/ _jsx(_Fragment, {});
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "border-x ellipsis text-center br-bottom-gray",
                                                style: {
                                                    borderColor: "#FFF"
                                                },
                                                children: item.rsDetail.map(function(b, i) {
                                                    return b.rs_detail_amount && b.rs_detail_amount > 0 ? /*#__PURE__*/ _jsx("p", {
                                                        className: "py-[10px]",
                                                        children: "".concat(b.set_unit_name)
                                                    }, i) : /*#__PURE__*/ _jsx(_Fragment, {});
                                                })
                                            })
                                        ]
                                    }, index);
                                }) : /*#__PURE__*/ _jsx("tr", {
                                    style: {
                                        height: "30px"
                                    },
                                    children: /*#__PURE__*/ _jsx("td", {
                                        colSpan: 7,
                                        className: "text-center py-4",
                                        children: "ไม่พบข้อมูล"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row my-3",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-12 text-end text-[11.5px]",
                        children: [
                            "วันที่ __________/__________/__________",
                            " "
                        ]
                    })
                })
            ]
        })
    });
});
var shippingLabelStyles = StyleSheet.create({
    page: {
        padding: 8,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 8,
        color: "#111111"
    },
    frame: {
        flexGrow: 1,
        borderWidth: 0.8,
        borderColor: "#111111",
        borderRadius: 3,
        padding: 9
    },
    headerRow: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: 18,
        paddingHorizontal: 2,
        paddingBottom: 4
    },
    senderHeading: {
        fontSize: 12,
        fontWeight: "bold"
    },
    printedDateTime: {
        fontSize: 8,
        textAlign: "right"
    },
    divider: {
        borderBottomWidth: 0.7,
        borderBottomColor: "#777777"
    },
    barcodeArea: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
        paddingTop: 4,
        paddingBottom: 4
    },
    barcodeColumn: {
        flexGrow: 1,
        flexBasis: 0,
        paddingRight: 10
    },
    shippingIdBox: {
        width: 44,
        height: 44,
        marginRight: 4,
        borderRadius: 8,
        backgroundColor: "#000000",
        alignItems: "center",
        justifyContent: "center"
    },
    shippingIdText: {
        width: "100%",
        position: "relative",
        top: -5,
        color: "#FFFFFF",
        fontSize: 25,
        fontWeight: "bold",
        lineHeight: 1,
        textAlign: "center"
    },
    contactCard: {
        position: "relative",
        flexShrink: 0,
        borderWidth: 0.8,
        borderColor: "#222222",
        borderRadius: 5,
        marginHorizontal: 0,
        marginTop: 14,
        paddingTop: 15,
        paddingRight: 8,
        paddingBottom: 8,
        paddingLeft: 20,
        minHeight: 70,
        overflow: "visible"
    },
    recipientCard: {
        minHeight: 140,
        paddingBottom: 8
    },
    shippingCard: {
        minHeight: 45
    },
    badge: {
        position: "absolute",
        top: -9,
        left: 7,
        minWidth: 45,
        height: 19,
        paddingHorizontal: 6,
        borderRadius: 4,
        backgroundColor: "#000000",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center"
    },
    badgeIcon: {
        marginRight: 4
    },
    badgeText: {
        color: "#FFFFFF",
        fontSize: 8,
        fontWeight: "bold"
    },
    contactName: {
        fontSize: 10.5,
        fontWeight: "bold",
        lineHeight: 1.35,
        marginBottom: 2
    },
    contactText: {
        fontSize: 10,
        lineHeight: 1.35
    },
    recipientName: {
        fontSize: 13,
        fontWeight: "bold",
        lineHeight: 1.35,
        marginBottom: 2
    },
    recipientText: {
        fontSize: 12,
        lineHeight: 1.35
    },
    twoColumnRow: {
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-start"
    },
    leftColumn: {
        width: "50%",
        paddingRight: 5
    },
    rightColumn: {
        width: "50%",
        paddingLeft: 5
    },
    recipientContactRow: {
        marginBottom: 3
    },
    recipientContactName: {
        fontSize: 12,
        lineHeight: 1.35
    },
    recipientPhone: {
        fontSize: 14,
        fontWeight: "bold",
        lineHeight: 1.3,
        textAlign: "right"
    },
    shippingInfoText: {
        fontSize: 14,
        fontWeight: "bold",
        lineHeight: 1.3
    },
    shippingPayText: {
        fontSize: 14,
        fontWeight: "bold",
        lineHeight: 1.3,
        textAlign: "right"
    }
});
var ShippingLabelBadge = function(param) {
    var type = param.type, children = param.children;
    return /*#__PURE__*/ _jsxs(View, {
        style: shippingLabelStyles.badge,
        children: [
            /*#__PURE__*/ _jsx(Svg, {
                style: shippingLabelStyles.badgeIcon,
                width: 9,
                height: 9,
                viewBox: "0 0 24 24",
                children: /*#__PURE__*/ _jsx(Path, {
                    fill: "#FFFFFF",
                    d: type === "sender" ? "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" : type === "shipping" ? "M20 8h-3V4H3C1.9 4 1 4.9 1 6v11h2a3 3 0 0 0 6 0h6a3 3 0 0 0 6 0h2v-5l-3-4zM6 18.5A1.5 1.5 0 1 1 6 15a1.5 1.5 0 0 1 0 3.5zM17 6h2l2.3 3H17V6zm1 12.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" : "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                style: shippingLabelStyles.badgeText,
                children: children
            })
        ]
    });
};
function ShippingLabelDocument(param) {
    var dataFrom = param.dataFrom;
    var _dataFrom_shShop, _dataFrom_shBranch, _dataFrom_shBranch1, _dataFrom_shBranch2, _dataFrom_shBranch3, _dataFrom_shBranch4, _dataFrom_shBranch_setShipping, _dataFrom_shBranch5, _dataFrom_shBranch_setShipping1, _dataFrom_shBranch6;
    var printedDateTime = moment().format("DD/MM/YYYY HH:mm");
    var senderName = (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.shipping_label_sender_name) || "";
    var saleContact = [
        dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.reserve_salename,
        dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.reserve_salephone
    ].filter(Boolean).join(" ");
    var senderAddress = (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.shipping_label_sender_address) || "";
    var shopName = (dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shShop = dataFrom.shShop) === null || _dataFrom_shShop === void 0 ? void 0 : _dataFrom_shShop.sh_shop_name) || "";
    var branchName = formatPdfBranchName((dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch = dataFrom.shBranch) === null || _dataFrom_shBranch === void 0 ? void 0 : _dataFrom_shBranch.sh_branch_name) || (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_branchname), dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch1 = dataFrom.shBranch) === null || _dataFrom_shBranch1 === void 0 ? void 0 : _dataFrom_shBranch1.sh_branch_code);
    var recipientName = shopName && branchName ? "".concat(shopName, " (").concat(branchName) : shopName || branchName;
    var recipientNameClosing = shopName && branchName ? ")" : "";
    var contactName = (dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch2 = dataFrom.shBranch) === null || _dataFrom_shBranch2 === void 0 ? void 0 : _dataFrom_shBranch2.sh_branch_recipient_name) || "";
    var contactPhone = (dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch3 = dataFrom.shBranch) === null || _dataFrom_shBranch3 === void 0 ? void 0 : _dataFrom_shBranch3.sh_branch_recipient_phone) || "";
    var recipientAddress = (dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch4 = dataFrom.shBranch) === null || _dataFrom_shBranch4 === void 0 ? void 0 : _dataFrom_shBranch4.sh_branch_address) || "";
    var formattedRecipientAddress = recipientAddress + "  ";
    var shippingCompanyName = (dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch5 = dataFrom.shBranch) === null || _dataFrom_shBranch5 === void 0 ? void 0 : (_dataFrom_shBranch_setShipping = _dataFrom_shBranch5.setShipping) === null || _dataFrom_shBranch_setShipping === void 0 ? void 0 : _dataFrom_shBranch_setShipping.set_shipping_name) || "";
    var _dataFrom_shBranch_setShipping_set_shipping_id;
    var shippingCompanyId = (_dataFrom_shBranch_setShipping_set_shipping_id = dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch6 = dataFrom.shBranch) === null || _dataFrom_shBranch6 === void 0 ? void 0 : (_dataFrom_shBranch_setShipping1 = _dataFrom_shBranch6.setShipping) === null || _dataFrom_shBranch_setShipping1 === void 0 ? void 0 : _dataFrom_shBranch_setShipping1.set_shipping_id) !== null && _dataFrom_shBranch_setShipping_set_shipping_id !== void 0 ? _dataFrom_shBranch_setShipping_set_shipping_id : "-";
    var shippingPayType = Number(dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_shipping_paytype);
    var shippingPayTypeText = shippingPayType === 1 ? "ເກັບຕົ້ນທາງ" : shippingPayType === 2 ? "ເກັບປາຍທາງ" : "";
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsx(Page, {
            size: "A6",
            orientation: "portrait",
            style: shippingLabelStyles.page,
            children: /*#__PURE__*/ _jsxs(View, {
                style: shippingLabelStyles.frame,
                children: [
                    /*#__PURE__*/ _jsxs(View, {
                        style: shippingLabelStyles.headerRow,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                style: shippingLabelStyles.senderHeading,
                                children: "Pardesco"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: shippingLabelStyles.printedDateTime,
                                children: [
                                    "ວັນທີພິມ: ",
                                    printedDateTime
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: shippingLabelStyles.divider
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: shippingLabelStyles.barcodeArea,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: shippingLabelStyles.barcodeColumn,
                                children: /*#__PURE__*/ _jsx(PdfBarcode, {
                                    value: (dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_code) || "",
                                    height: 34,
                                    viewBoxHeight: 25,
                                    textGap: 3
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: shippingLabelStyles.shippingIdBox,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: shippingLabelStyles.shippingIdText,
                                    children: shippingCompanyId
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: shippingLabelStyles.divider
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: shippingLabelStyles.contactCard,
                        wrap: false,
                        children: [
                            /*#__PURE__*/ _jsx(ShippingLabelBadge, {
                                type: "sender",
                                children: "ຜູ້ສົ່ງ"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: shippingLabelStyles.contactName,
                                children: senderName
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: shippingLabelStyles.contactText,
                                children: saleContact || "-"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: shippingLabelStyles.contactText,
                                children: senderAddress
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: [
                            shippingLabelStyles.contactCard,
                            shippingLabelStyles.recipientCard
                        ],
                        wrap: false,
                        children: [
                            /*#__PURE__*/ _jsx(ShippingLabelBadge, {
                                type: "recipient",
                                children: "ຜູ້ຮັບ"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                style: shippingLabelStyles.recipientName,
                                children: [
                                    recipientName,
                                    recipientNameClosing ? /*#__PURE__*/ _jsx(Text, {
                                        children: recipientNameClosing
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    shippingLabelStyles.twoColumnRow,
                                    shippingLabelStyles.recipientContactRow
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: shippingLabelStyles.leftColumn,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: shippingLabelStyles.recipientContactName,
                                            children: contactName
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: shippingLabelStyles.rightColumn,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: shippingLabelStyles.recipientPhone,
                                            children: contactPhone
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                style: shippingLabelStyles.recipientText,
                                children: formattedRecipientAddress
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(View, {
                        style: [
                            shippingLabelStyles.contactCard,
                            shippingLabelStyles.shippingCard
                        ],
                        wrap: false,
                        children: [
                            /*#__PURE__*/ _jsx(ShippingLabelBadge, {
                                type: "shipping",
                                children: "ຂໍ້ມູນຂົນສົ່ງ"
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: shippingLabelStyles.twoColumnRow,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: shippingLabelStyles.leftColumn,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: shippingLabelStyles.shippingInfoText,
                                            children: shippingCompanyName
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: shippingLabelStyles.rightColumn,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: shippingLabelStyles.shippingPayText,
                                            children: shippingPayTypeText
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
// Styles
var styles = StyleSheet.create({
    page: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: PDF_FONT_SIZE_BASE,
        padding: 30,
        lineHeight: 1.4
    },
    section: {
        marginBottom: 12
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start"
    },
    logo: {
        width: "auto",
        height: 40,
        marginBottom: 1
    },
    textHeaderCompany: {
        fontSize: PDF_FONT_SIZE_SUBTITLE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold",
        marginBottom: 1
    },
    textDetailCompany: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    centerHeaderText: {
        textAlign: "center",
        marginVertical: 12,
        fontSize: PDF_FONT_SIZE_TITLE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold"
    },
    rightDetailText: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: PDF_FONT_SIZE_BASE,
        textAlign: "right"
    },
    paragraph: {
        fontSize: PDF_FONT_SIZE_BASE,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginVertical: 15
    },
    bold: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: PDF_FONT_SIZE_BASE,
        fontWeight: "bold"
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 20,
        right: 20,
        textAlign: "right",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: PDF_FONT_SIZE_SUBTITLE,
        fontWeight: "bold"
    },
    sectionHeader: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: PDF_FONT_SIZE_BASE,
        fontWeight: "bold"
    },
    paragraphSignature: {
        fontSize: PDF_FONT_SIZE_BASE,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginVertical: 40
    },
    paragraphTextC: {
        fontSize: PDF_FONT_SIZE_BASE,
        lineHeight: 1.2,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginBottom: 1
    },
    paddingLeftTextS1: {
        paddingLeft: 40
    },
    paddingLeftTextS2: {
        paddingLeft: 60
    },
    signatureRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20,
        marginVertical: 40
    },
    signatureRow2: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20
    },
    signatureRow3: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginVertical: 10
    },
    signatureColumnLeft: {
        width: "48%"
    },
    signatureColumnRight: {
        width: "32%"
    },
    signatureBlock: {
        textAlign: "center",
        alignItems: "center",
        marginBottom: 24
    },
    signatureBox: {
        minWidth: "45%",
        alignItems: "center"
    },
    signatureLine: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginBottom: 4,
        textAlign: "center",
        fontWeight: "bold"
    },
    signatureName: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        textAlign: "center",
        fontWeight: "bold"
    },
    paragraphPadding_40: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginVertical: 5,
        paddingLeft: 40
    },
    channelRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingLeft: 100,
        marginVertical: 10
    },
    channelBox: {
        minWidth: "45%",
        alignItems: "start"
    },
    channelLine: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginBottom: 4,
        textAlign: "left"
    },
    channelName: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        textAlign: "left"
    },
    table: {
        display: "flex",
        width: "auto",
        //borderStyle: 'solid',
        //borderWidth: 1,
        //borderColor: '#000',
        borderBottomWidth: 0
    },
    tableRow: {
        flexDirection: "row"
    },
    tableColHeader: {
        //width: '25%',
        borderStyle: "solid",
        borderWidth: 1,
        justifyContent: "center",
        borderColor: "#F6E1E3",
        backgroundColor: "#F6E1E3",
        // borderLeftWidth: 0,
        // borderTopWidth: 0,
        paddingVertical: 1,
        paddingHorizontal: 3
    },
    tableCol: {
        //width: '25%',
        justifyContent: "center",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#909090",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth: 0,
        padding: 1
    },
    tableCellHeader: {
        fontSize: PDF_FONT_SIZE_BASE - 1,
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        width: "100%",
        lineHeight: 1.2
    },
    tableCell: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        justifyContent: "center"
    },
    tableCol3P: {
        width: "3%"
    },
    tableCol5P: {
        width: "5%"
    },
    tableCol7P: {
        width: "7%"
    },
    tableCol10P: {
        width: "10%"
    },
    tableCol15P: {
        width: "15%"
    },
    tableCol20P: {
        width: "20%"
    },
    tableCol25P: {
        width: "25%"
    },
    tableCol30P: {
        width: "30%"
    },
    tableCol35P: {
        width: "35%"
    },
    tableCol40P: {
        width: "40%"
    },
    tableCol45P: {
        width: "45%"
    },
    tableCol50P: {
        width: "50%"
    },
    tableCol85P: {
        width: "85%"
    },
    topInfoLeftWrap: {
        width: "70%"
    },
    topInfoColumns: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    topInfoColumn: {
        width: "49%"
    },
    boxInfoPartner: {
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: 60
    },
    boxInfoDocument: {
        fontSize: PDF_FONT_SIZE_TITLE + 2,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold",
        color: "rgba(220,53,69,1)"
    },
    documentHeading: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0,
        marginLeft: 8
    },
    documentNumber: {
        fontSize: 38,
        lineHeight: 1,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold",
        color: "rgba(230,35,19,1)",
        marginRight: 8
    },
    documentHeadingText: {
        alignItems: "flex-start"
    },
    textDetail14P: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        justifyContent: "center"
    },
    textDetail14B: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold",
        justifyContent: "center"
    },
    textDetailInlineRow: {
        width: "100%",
        flexDirection: "row",
        alignItems: "flex-start"
    },
    textDetailInlineLabel: {
        width: 52,
        flexShrink: 0
    },
    textDetailInlineValue: {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0
    },
    textDetail16P: {
        fontSize: PDF_FONT_SIZE_BASE,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        justifyContent: "center"
    }
});
function ContractDocument(_param) {
    var dataFrom = _param.dataFrom, dataItem = _param.dataItem, props = _object_without_properties(_param, [
        "dataFrom",
        "dataItem"
    ]);
    var _dataFrom_shBranch, _dataFrom_rs_reserve_code, _dataFrom_shBranch1, _dataFrom_shBranch2;
    var rest = _extends({}, _object_destructuring_empty(props));
    var typeDocPrint = props.typeDocPrint ? props.typeDocPrint : 1;
    var docType = props.docType ? props.docType : DOC_TYPE_PICKING;
    var documentTitle = getPdfDocumentName(docType);
    var documentNumber = getPdfDocumentNumber(docType);
    var documentDateLabel = docType === DOC_TYPE_DELIVERY ? "วันที่จัดส่ง" : "วันที่จองสินค้า";
    var documentDateValue = docType === DOC_TYPE_DELIVERY ? dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_datedelivery : dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_credate;
    var _dataFrom_shBranch_sh_branch_vatcal, _ref;
    var branchVatCal = (_ref = (_dataFrom_shBranch_sh_branch_vatcal = dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_shBranch = dataFrom.shBranch) === null || _dataFrom_shBranch === void 0 ? void 0 : _dataFrom_shBranch.sh_branch_vatcal) !== null && _dataFrom_shBranch_sh_branch_vatcal !== void 0 ? _dataFrom_shBranch_sh_branch_vatcal : dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.sh_branch_vatcal) !== null && _ref !== void 0 ? _ref : 1;
    var lakExchangeRate = getLakExchangeRate(dataFrom);
    var showLakCurrency = [
        DOC_TYPE_DELIVERY,
        DOC_TYPE_PENDING,
        DOC_TYPE_NO_DELIVERY
    ].includes(docType);
    var storedReserveNetTotal = Number(docType === DOC_TYPE_DELIVERY ? dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_stnet : dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_net) || 0;
    var storedReservePriceTotal = Number(docType === DOC_TYPE_DELIVERY ? dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_stprice : dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_price) || storedReserveNetTotal;
    var fullReservePriceTotal = Number(dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_price) || Number(dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_net) || 0;
    var _dataFrom_rs_reserve_stdiscountreal;
    var storedReserveDiscountReal = Number(docType === DOC_TYPE_DELIVERY ? (_dataFrom_rs_reserve_stdiscountreal = dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_stdiscountreal) !== null && _dataFrom_rs_reserve_stdiscountreal !== void 0 ? _dataFrom_rs_reserve_stdiscountreal : Math.max(storedReservePriceTotal - storedReserveNetTotal, 0) : dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_discountreal) || 0;
    var reserveDiscountType = Number(dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_discounttype) === 2 ? 2 : 1;
    var reserveDiscount = Number(dataFrom === null || dataFrom === void 0 ? void 0 : dataFrom.rs_reserve_discount) || 0;
    var shouldPrintDetail = function(detail) {
        if (docType === DOC_TYPE_NO_DELIVERY) {
            var detailAmount = Number(detail === null || detail === void 0 ? void 0 : detail.rs_detail_amount);
            var deliveredAmount = Number(detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount);
            return detailAmount > 0 && (deliveredAmount === 0 || deliveredAmount > 0 && detailAmount > deliveredAmount);
        }
        var detailAmount1 = docType === DOC_TYPE_DELIVERY ? detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount : detail === null || detail === void 0 ? void 0 : detail.rs_detail_amount;
        return Number(detailAmount1) > 0;
    };
    var getNoDeliveryAmount = function(detail) {
        var detailAmount = Number(detail === null || detail === void 0 ? void 0 : detail.rs_detail_amount) || 0;
        var deliveredAmount = Number(detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount) || 0;
        return deliveredAmount === 0 ? detailAmount : Math.max(detailAmount - deliveredAmount, 0);
    };
    var printableDataItems = sortReservationCatalogItems(dataItem).map(function(item) {
        return docType === DOC_TYPE_NO_DELIVERY ? _object_spread_props(_object_spread({}, item), {
            rsDetail: Array.isArray(item === null || item === void 0 ? void 0 : item.rsDetail) ? item.rsDetail.filter(shouldPrintDetail) : []
        }) : item;
    }).filter(function(item) {
        if (docType === DOC_TYPE_NO_DELIVERY) {
            return !isComplimentaryReserveCatalog(item) && item.rsDetail.length > 0;
        }
        if (docType !== DOC_TYPE_DELIVERY) {
            return true;
        }
        var itemTotal = Array.isArray(item === null || item === void 0 ? void 0 : item.rsDetail) ? item.rsDetail.reduce(function(sum, detail) {
            return sum + (Number(detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount) || 0);
        }, 0) : 0;
        return itemTotal > 0;
    });
    var noDeliveryPriceTotal = printableDataItems.reduce(function(catalogTotal, item) {
        return catalogTotal + (isComplimentaryReserveCatalog(item) ? 0 : item.rsDetail.reduce(function(detailTotal, detail) {
            var detailNet = getReserveDetailUnitPrice(detail, branchVatCal) * getNoDeliveryAmount(detail);
            return detailTotal + detailNet;
        }, 0));
    }, 0);
    var reservePriceTotal = docType === DOC_TYPE_NO_DELIVERY ? noDeliveryPriceTotal : storedReservePriceTotal;
    var reserveDiscountReal = docType === DOC_TYPE_NO_DELIVERY ? Math.min(Math.max(fullReservePriceTotal > 0 ? storedReserveDiscountReal * reservePriceTotal / fullReservePriceTotal : 0, 0), reservePriceTotal) : storedReserveDiscountReal;
    var reserveNetTotal = docType === DOC_TYPE_NO_DELIVERY ? Math.max(reservePriceTotal - reserveDiscountReal, 0) : storedReserveNetTotal;
    var pdfTableWidths = {
        index: styles.tableCol3P,
        image: styles.tableCol10P,
        name: styles.tableCol25P,
        barcode: styles.tableCol15P,
        packageSize: styles.tableCol7P,
        quantity: styles.tableCol10P,
        quantityValue: styles.tableCol5P,
        quantityUnit: styles.tableCol5P,
        unitPrice: styles.tableCol15P,
        total: styles.tableCol15P
    };
    var cursor = new CursorManager(20, 20);
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.header,
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flexDirection: "row",
                                alignItems: "center",
                                flexGrow: 1,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/images/pardesco-logo-new-black-200.png",
                                    style: styles.logo
                                }),
                                docType === DOC_TYPE_DELIVERY && (dataFrom === null || dataFrom === void 0 ? void 0 : (_dataFrom_rs_reserve_code = dataFrom.rs_reserve_code) === null || _dataFrom_rs_reserve_code === void 0 ? void 0 : _dataFrom_rs_reserve_code.trim()) ? /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        width: 180,
                                        marginLeft: 14,
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ _jsx(PdfBarcode, {
                                        value: dataFrom.rs_reserve_code.trim(),
                                        height: 34
                                    })
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: styles.documentHeading,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.documentNumber,
                                    children: documentNumber
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: styles.documentHeadingText,
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 1
                                            }),
                                            children: [
                                                "(",
                                                "\xa0",
                                                typeDocPrint && typeDocPrint == 1 ? "ต้นฉบับ" : "สำเนา",
                                                "\xa0",
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: styles.boxInfoDocument,
                                            children: documentTitle
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.tableRow), {
                        marginTop: 10,
                        marginBottom: 5
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: styles.topInfoLeftWrap,
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: styles.topInfoColumns,
                                    children: [
                                        /*#__PURE__*/ _jsxs(View, {
                                            style: styles.topInfoColumn,
                                            children: [
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                        width: "100%",
                                                        marginBottom: 2
                                                    }),
                                                    children: [
                                                        "ลูกค้า",
                                                        "\xa0",
                                                        ":",
                                                        "\xa0",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: _object_spread({}, styles.textDetail14B),
                                                            children: dataFrom && dataFrom.rs_reserve_shopname && dataFrom.rs_reserve_shopname != "" && dataFrom.rs_reserve_shopname != null ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                children: [
                                                                    dataFrom.rs_reserve_shopname.trim() + "\xa0",
                                                                    dataFrom.rs_reserve_branchname && dataFrom.rs_reserve_branchname != "" && dataFrom.rs_reserve_branchname != null && dataFrom.rs_reserve_branchname != "สำนักงานใหญ่" ? "(สาขา " + formatPdfBranchName(dataFrom.rs_reserve_branchname, (_dataFrom_shBranch1 = dataFrom.shBranch) === null || _dataFrom_shBranch1 === void 0 ? void 0 : _dataFrom_shBranch1.sh_branch_code) + ")" : "(".concat(formatPdfBranchName("สำนักงานใหญ่", (_dataFrom_shBranch2 = dataFrom.shBranch) === null || _dataFrom_shBranch2 === void 0 ? void 0 : _dataFrom_shBranch2.sh_branch_code), ")")
                                                                ]
                                                            }) : "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                        width: "100%",
                                                        marginBottom: 2
                                                    }),
                                                    children: [
                                                        "ผู้ติดต่อ",
                                                        "\xa0",
                                                        "1",
                                                        "\xa0",
                                                        ":",
                                                        "\xa0",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: _object_spread({}, styles.textDetail14B),
                                                            children: dataFrom && dataFrom.rs_reserve_contactname && dataFrom.rs_reserve_contactname != "" && dataFrom.rs_reserve_contactname != null ? dataFrom.rs_reserve_contactname.trim() : "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                        width: "100%",
                                                        marginBottom: 2
                                                    }),
                                                    children: [
                                                        "เบอร์โทรศัพท์",
                                                        "\xa0",
                                                        ":",
                                                        "\xa0",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: _object_spread({}, styles.textDetail14B),
                                                            children: dataFrom && dataFrom.rs_reserve_contactphone && dataFrom.rs_reserve_contactphone != "" && dataFrom.rs_reserve_contactphone != null ? dataFrom.rs_reserve_contactphone.trim() : "-"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(View, {
                                            style: styles.topInfoColumn,
                                            children: [
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                        width: "100%",
                                                        marginBottom: 2
                                                    }),
                                                    children: [
                                                        "เซลล์ที่ดูแล",
                                                        "\xa0",
                                                        ":",
                                                        "\xa0",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: _object_spread({}, styles.textDetail14B),
                                                            children: dataFrom && dataFrom.reserve_salename && dataFrom.reserve_salename != "" && dataFrom.reserve_salename != null ? dataFrom.reserve_salename.trim() : "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                        width: "100%",
                                                        marginBottom: 2
                                                    }),
                                                    children: [
                                                        "ผู้ติดต่อ",
                                                        "\xa0",
                                                        "2",
                                                        "\xa0",
                                                        ":",
                                                        "\xa0",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: _object_spread({}, styles.textDetail14B),
                                                            children: dataFrom && dataFrom.rs_reserve_suptactname && dataFrom.rs_reserve_suptactname != "" && dataFrom.rs_reserve_suptactname != null ? dataFrom.rs_reserve_suptactname.trim() : "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                        width: "100%",
                                                        marginBottom: 2
                                                    }),
                                                    children: [
                                                        "เบอร์โทรศัพท์",
                                                        "\xa0",
                                                        ":",
                                                        "\xa0",
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: _object_spread({}, styles.textDetail14B),
                                                            children: dataFrom && dataFrom.rs_reserve_suptactphone && dataFrom.rs_reserve_suptactphone != "" && dataFrom.rs_reserve_suptactphone != null ? dataFrom.rs_reserve_suptactphone.trim() : "-"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    children: /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                            width: "100%"
                                        }),
                                        children: [
                                            "เครดิต",
                                            "\xa0",
                                            ":",
                                            "\xa0",
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread({}, styles.textDetail14B),
                                                children: dataFrom && dataFrom.rs_reserve_credit && dataFrom.rs_reserve_credit != "" && dataFrom.rs_reserve_credit != null ? dataFrom.rs_reserve_credit.trim() : "-"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol30P), {
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: 5
                            }),
                            children: [
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        width: "100%",
                                        marginBottom: 2
                                    }),
                                    children: [
                                        "เลขที่เอกสาร",
                                        "\xa0",
                                        ":",
                                        "\xa0",
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread({}, styles.textDetail14B),
                                            children: dataFrom && dataFrom.rs_reserve_code && dataFrom.rs_reserve_code != "" && dataFrom.rs_reserve_code != null ? dataFrom.rs_reserve_code.trim() : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        width: "100%",
                                        marginBottom: 2
                                    }),
                                    children: [
                                        documentDateLabel,
                                        "\xa0",
                                        ":",
                                        "\xa0",
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread({}, styles.textDetail14B),
                                            children: documentDateValue && documentDateValue != "" && documentDateValue != null ? formatDbDate(documentDateValue) : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        width: "100%",
                                        marginBottom: 2
                                    }),
                                    children: [
                                        "วันที่เซลล์ติดต่อ",
                                        "\xa0",
                                        ":",
                                        "\xa0",
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread({}, styles.textDetail14B),
                                            children: dataFrom && dataFrom.rs_reserve_saledate && dataFrom.rs_reserve_saledate != "" && dataFrom.rs_reserve_saledate != null ? formatDbDate(dataFrom.rs_reserve_saledate) : "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        width: "100%"
                                    }),
                                    children: [
                                        "วันที่อนุมัติ",
                                        "\xa0",
                                        ":",
                                        "\xa0",
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread({}, styles.textDetail14B),
                                            children: dataFrom && dataFrom.rs_reserve_approvedate && dataFrom.rs_reserve_approvedate != "" && dataFrom.rs_reserve_approvedate != null ? formatDbDate(dataFrom.rs_reserve_approvedate) : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread_props(_object_spread({}, styles.table), {
                        marginBottom: 10
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: styles.tableRow,
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.index),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "#"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.image),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "รูปสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.name),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "ชื่อสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.barcode),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "บาร์โค้ด"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.packageSize),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "ขนาดบรรจุ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.quantity),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: styles.tableCellHeader,
                                        children: "จำนวนสินค้า "
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.unitPrice),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCellHeader), {
                                            textAlign: "right"
                                        }),
                                        children: "ราคาต่อหน่วย"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: _object_spread({}, styles.tableColHeader, pdfTableWidths.total),
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCellHeader), {
                                            textAlign: "right"
                                        }),
                                        children: "ยอดรวม"
                                    })
                                })
                            ]
                        }),
                        printableDataItems.length > 0 ? printableDataItems.map(function(item, index) {
                            var _item_setPromotion;
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                wrap: false,
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.index),
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                textAlign: "center"
                                            }),
                                            children: "".concat(index + 1)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread_props(_object_spread({}, styles.tableCol, pdfTableWidths.image), {
                                            alignItems: "center"
                                        }),
                                        children: item.rs_catalog_image && item.rs_catalog_image != "" && item.rs_catalog_image != null ? /*#__PURE__*/ _jsx(Image, {
                                            src: item.rs_catalog_image,
                                            style: {
                                                maxWidth: 60,
                                                maxHeight: 60
                                            }
                                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                    }),
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.name),
                                        children: [
                                            Number(item.rs_catalog_free) === 2 ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    fontSize: PDF_FONT_SIZE_BASE - 1,
                                                    color: "#B00412"
                                                }),
                                                children: "ของแถม"
                                            }) : null,
                                            Number(item.rs_catalog_tester) === 2 ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    fontSize: PDF_FONT_SIZE_BASE - 1,
                                                    color: "#B00412"
                                                }),
                                                children: "สินค้าทดลอง"
                                            }) : null,
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textWrap: "balance"
                                                }),
                                                children: "".concat(item.rs_catalog_name)
                                            }),
                                            ((_item_setPromotion = item.setPromotion) === null || _item_setPromotion === void 0 ? void 0 : _item_setPromotion.set_promotion_name) ? /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textWrap: "balance",
                                                    fontSize: PDF_FONT_SIZE_BASE - 1,
                                                    color: "#B00412"
                                                }),
                                                children: [
                                                    "Promotion: ",
                                                    item.setPromotion.set_promotion_name
                                                ]
                                            }) : null,
                                            docType === DOC_TYPE_NO_DELIVERY ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textWrap: "balance",
                                                    fontSize: PDF_FONT_SIZE_BASE - 1,
                                                    color: "#B00412"
                                                }),
                                                children: item.rsDetail.some(function(detail) {
                                                    return Number(detail === null || detail === void 0 ? void 0 : detail.rs_detail_stamount) === 0;
                                                }) ? "สินค้าหมด\xa0" : "ส่งสินค้าไม่ตรงตามจำนวนที่จอง\xa0"
                                            }) : null,
                                            item.rs_catalog_remark ? /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textWrap: "balance",
                                                    fontSize: PDF_FONT_SIZE_BASE - 1
                                                }),
                                                children: [
                                                    "หมายเหตุ: ",
                                                    item.rs_catalog_remark
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.barcode),
                                        children: item.rsDetail.map(function(b, i) {
                                            return shouldPrintDetail(b) ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center",
                                                    width: "100%"
                                                }),
                                                children: "".concat(b.rs_detail_barcode)
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center",
                                                    width: "100%"
                                                })
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.packageSize),
                                        children: item.rsDetail.map(function(b, i) {
                                            return shouldPrintDetail(b) ? /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center",
                                                    width: "100%"
                                                }),
                                                children: [
                                                    b.rs_detail_ratio && b.rs_detail_ratio > 0 ? " ".concat(b.rs_detail_ratio) : "",
                                                    "\xa0",
                                                    b.rs_detail_ratio && b.rs_detail_ratio > 0 ? "ชิ้น" : ""
                                                ]
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "center",
                                                    width: "100%"
                                                })
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.quantityValue),
                                        children: item.rsDetail.map(function(b, i) {
                                            return shouldPrintDetail(b) ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right",
                                                    width: "100%"
                                                }),
                                                children: "".concat(NumberFormat(docType === DOC_TYPE_DELIVERY ? b.rs_detail_stamount : docType === DOC_TYPE_NO_DELIVERY ? getNoDeliveryAmount(b) : b.rs_detail_amount, 0))
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: "100%"
                                                }
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.quantityUnit),
                                        children: item.rsDetail.map(function(b, i) {
                                            return shouldPrintDetail(b) ? /*#__PURE__*/ _jsx(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "left",
                                                    width: "100%"
                                                }),
                                                children: "".concat(b.set_unit_name)
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: "100%"
                                                }
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.unitPrice),
                                        children: item.rsDetail.map(function(b, i) {
                                            return shouldPrintDetail(b) ? /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right",
                                                    width: "100%"
                                                }),
                                                children: [
                                                    "".concat(NumberFormat(getReserveDetailUnitPrice(b, branchVatCal), 2)),
                                                    showLakCurrency ? /*#__PURE__*/ _jsx(Text, {
                                                        style: pdfLakTextStyle,
                                                        children: "\nLAK ".concat(NumberFormat(getLakAmount(getReserveDetailUnitPrice(b, branchVatCal), lakExchangeRate), 2))
                                                    }) : null
                                                ]
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: "100%"
                                                }
                                            });
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: _object_spread({}, styles.tableCol, pdfTableWidths.total),
                                        children: item.rsDetail.map(function(b, i) {
                                            return shouldPrintDetail(b) ? /*#__PURE__*/ _jsxs(Text, {
                                                style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                                    textAlign: "right",
                                                    width: "100%"
                                                }),
                                                children: [
                                                    "".concat(NumberFormat(docType === DOC_TYPE_DELIVERY ? b.rs_detail_stnet : docType === DOC_TYPE_NO_DELIVERY ? getReserveDetailUnitPrice(b, branchVatCal) * getNoDeliveryAmount(b) : b.rs_detail_net, 2)),
                                                    showLakCurrency ? /*#__PURE__*/ _jsx(Text, {
                                                        style: pdfLakTextStyle,
                                                        children: "\nLAK ".concat(NumberFormat(getLakAmount(docType === DOC_TYPE_DELIVERY ? b.rs_detail_stnet : docType === DOC_TYPE_NO_DELIVERY ? getReserveDetailUnitPrice(b, branchVatCal) * getNoDeliveryAmount(b) : b.rs_detail_net, lakExchangeRate), 2))
                                                    }) : null
                                                ]
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: "100%"
                                                }
                                            });
                                        })
                                    })
                                ]
                            }, index);
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(View, {
                                style: _object_spread_props(_object_spread({}, styles.tableCol), {
                                    width: "100%"
                                }),
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.tableCell), {
                                        textAlign: "center",
                                        fontWeight: "bold"
                                    }),
                                    children: "ไม่พบข้อมูล"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread({}, styles.tableRow),
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P, styles.tableCol85P), {
                                textAlign: "right"
                            }),
                            children: "ราคาสุทธิก่อนหักส่วนลด"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14B, styles.tableCol15P), {
                                textAlign: "right"
                            }),
                            children: "".concat(NumberFormat(reservePriceTotal, 2))
                        })
                    ]
                }),
                showLakCurrency ? /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread({}, styles.tableRow),
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P, styles.tableCol85P, pdfLakTextStyle), {
                                textAlign: "right"
                            }),
                            children: "ราคาสุทธิก่อนหักส่วนลด LAK"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14B, styles.tableCol15P, pdfLakTextStyle), {
                                textAlign: "right"
                            }),
                            children: "".concat(NumberFormat(getLakAmount(reservePriceTotal, lakExchangeRate), 2))
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread({}, styles.tableRow),
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P, styles.tableCol85P), {
                                textAlign: "right"
                            }),
                            children: [
                                "ส่วนลด ",
                                reserveDiscountType === 2 ? "".concat(NumberFormat(reserveDiscount, 2), "%") : ""
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14B, styles.tableCol15P), {
                                textAlign: "right"
                            }),
                            children: "".concat(NumberFormat(reserveDiscountReal, 2))
                        })
                    ]
                }),
                showLakCurrency ? /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread({}, styles.tableRow),
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P, styles.tableCol85P, pdfLakTextStyle), {
                                textAlign: "right"
                            }),
                            children: [
                                "ส่วนลด ",
                                reserveDiscountType === 2 ? "".concat(NumberFormat(reserveDiscount, 2), "%") : "",
                                " LAK"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14B, styles.tableCol15P, pdfLakTextStyle), {
                                textAlign: "right"
                            }),
                            children: "".concat(NumberFormat(getLakAmount(reserveDiscountReal, lakExchangeRate), 2))
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread({}, styles.tableRow),
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P, styles.tableCol85P), {
                                textAlign: "right"
                            }),
                            children: "รวมเป็นเงิน"
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14B, styles.tableCol15P), {
                                textAlign: "right"
                            }),
                            children: "".concat(NumberFormat(reserveNetTotal, 2))
                        })
                    ]
                }),
                showLakCurrency ? /*#__PURE__*/ _jsxs(View, {
                    style: _object_spread({}, styles.tableRow),
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14P, styles.tableCol85P, pdfLakTextStyle), {
                                textAlign: "right"
                            }),
                            children: [
                                "(",
                                NumberFormat(lakExchangeRate, 2),
                                ") รวมเป็นเงิน LAK"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread_props(_object_spread({}, styles.textDetail14B, styles.tableCol15P, pdfLakTextStyle), {
                                textAlign: "right"
                            }),
                            children: "".concat(NumberFormat(getLakAmount(reserveNetTotal, lakExchangeRate), 2))
                        })
                    ]
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.textDetailInlineRow,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread({}, styles.textDetail14P, styles.textDetailInlineLabel),
                            children: "หมายเหตุ :"
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.textDetailInlineValue,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                    width: "100%"
                                }),
                                children: dataFrom && dataFrom.rs_reserve_remark && dataFrom.rs_reserve_remark != "" && dataFrom.rs_reserve_remark != null ? dataFrom.rs_reserve_remark.trim() : "-"
                            })
                        })
                    ]
                }),
                docType !== DOC_TYPE_DELIVERY ? /*#__PURE__*/ _jsxs(View, {
                    style: styles.textDetailInlineRow,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: _object_spread({}, styles.textDetail14P, styles.textDetailInlineLabel),
                            children: "โน้ตภายใน :"
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.textDetailInlineValue,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                    width: "100%"
                                }),
                                children: dataFrom && dataFrom.rs_reserve_note && dataFrom.rs_reserve_note != "" && dataFrom.rs_reserve_note != null ? dataFrom.rs_reserve_note.trim() : "-"
                            })
                        })
                    ]
                }) : null,
                docType === DOC_TYPE_DELIVERY ? /*#__PURE__*/ _jsxs(View, {
                    style: styles.signatureRow3,
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: styles.signatureColumnLeft,
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: styles.signatureBlock,
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 10
                                            }),
                                            children: "ฝ่ายขาย"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 10
                                            }),
                                            children: [
                                                "ลงชื่อ",
                                                "\xa0",
                                                "............................................."
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                marginBottom: 10
                                            }),
                                            children: [
                                                "(",
                                                "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread({}, styles.textDetail14P),
                                            children: [
                                                "วันที่",
                                                "\xa0",
                                                "____/____/____"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: styles.signatureBlock,
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 10
                                            }),
                                            children: "ฝ่ายคลังสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 10
                                            }),
                                            children: [
                                                "ลงชื่อ",
                                                "\xa0",
                                                "............................................."
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                marginBottom: 10
                                            }),
                                            children: [
                                                "(",
                                                "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread({}, styles.textDetail14P),
                                            children: [
                                                "วันที่",
                                                "\xa0",
                                                "____/____/____"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: _object_spread_props(_object_spread({}, styles.signatureBlock), {
                                        marginBottom: 0
                                    }),
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 10
                                            }),
                                            children: "เจ้าหน้าที่จัดส่งสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                                marginBottom: 10
                                            }),
                                            children: [
                                                "ลงชื่อ",
                                                "\xa0",
                                                "............................................."
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                                marginBottom: 10
                                            }),
                                            children: [
                                                "(",
                                                "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: _object_spread({}, styles.textDetail14P),
                                            children: [
                                                "วันที่",
                                                "\xa0",
                                                "____/____/____"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.signatureColumnRight,
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: _object_spread_props(_object_spread({}, styles.signatureBlock), {
                                    marginBottom: 0
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                            marginBottom: 10
                                        }),
                                        children: "ผู้รับสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                            marginBottom: 10
                                        }),
                                        children: [
                                            "ลงชื่อ",
                                            "\xa0",
                                            "............................................."
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                            marginBottom: 10
                                        }),
                                        children: [
                                            "(",
                                            "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Text, {
                                        style: _object_spread({}, styles.textDetail14P),
                                        children: [
                                            "วันที่",
                                            "\xa0",
                                            "____/____/____"
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs(View, {
                    style: styles.signatureRow3,
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol30P), {
                                textAlign: "center"
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                        marginBottom: 10
                                    }),
                                    children: "ฝ่ายขาย"
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                        marginBottom: 10
                                    }),
                                    children: [
                                        "ลงชื่อ",
                                        "\xa0",
                                        "............................................."
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        marginBottom: 10
                                    }),
                                    children: [
                                        "(",
                                        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread({}, styles.textDetail14P),
                                    children: [
                                        "วันที่",
                                        "\xa0",
                                        "____/____/____"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol30P), {
                                textAlign: "center"
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                        marginBottom: 10
                                    }),
                                    children: "ฝ่ายธุรการ"
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                        marginBottom: 10
                                    }),
                                    children: [
                                        "ลงชื่อ",
                                        "\xa0",
                                        "............................................."
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        marginBottom: 10
                                    }),
                                    children: [
                                        "(",
                                        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread({}, styles.textDetail14P),
                                    children: [
                                        "วันที่",
                                        "\xa0",
                                        "____/____/____"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: _object_spread_props(_object_spread({}, styles.tableCol30P), {
                                textAlign: "center"
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                        marginBottom: 10
                                    }),
                                    children: "ฝ่ายคลังสินค้า"
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14B), {
                                        marginBottom: 10
                                    }),
                                    children: [
                                        "ลงชื่อ",
                                        "\xa0",
                                        "............................................."
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread_props(_object_spread({}, styles.textDetail14P), {
                                        marginBottom: 10
                                    }),
                                    children: [
                                        "(",
                                        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Text, {
                                    style: _object_spread({}, styles.textDetail14P),
                                    children: [
                                        "วันที่",
                                        "\xa0",
                                        "____/____/____"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
